var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _polygon, _rect, _rect2, _rect3, _rect4, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M683.78,295.08l6.18-10-3.05-1.89a2.77,2.77,0,0,1-1.29-2.62,14.55,14.55,0,0,0,0-1.75,2.8,2.8,0,0,1,1.46-2.53l3.16-1.69-5.54-10.33-3.16,1.7a2.8,2.8,0,0,1-2.91-.19c-.48-.33-1-.64-1.49-.92a2.79,2.79,0,0,1-1.47-2.53l.11-3.58-11.7-.37L664,262a2.77,2.77,0,0,1-1.64,2.42l-.77.39-.75.43a2.78,2.78,0,0,1-2.9,0l-3.07-1.9-6.18,9.95,3,1.9a2.78,2.78,0,0,1,1.3,2.62,14.46,14.46,0,0,0-.06,1.74,2.79,2.79,0,0,1-1.46,2.53l-3.16,1.69,5.54,10.33,3.16-1.69a2.78,2.78,0,0,1,2.91.18,15.17,15.17,0,0,0,1.48.92,2.8,2.8,0,0,1,1.48,2.53l-.12,3.59,11.71.36.11-3.59a2.81,2.81,0,0,1,1.63-2.42l.78-.39c.25-.13.5-.28.75-.43a2.81,2.81,0,0,1,2.92,0Zm-9.91-7.4a9.59,9.59,0,1,1,3.93-13A9.59,9.59,0,0,1,673.87,287.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.11,207.47l6.18-10-3.05-1.88A2.78,2.78,0,0,1,97,193a14.72,14.72,0,0,0,0-1.76,2.77,2.77,0,0,1,1.46-2.52l3.16-1.7-5.54-10.32-3.16,1.69a2.78,2.78,0,0,1-2.91-.19c-.48-.33-1-.64-1.49-.92a2.79,2.79,0,0,1-1.47-2.53l.12-3.58-11.71-.37-.11,3.6a2.79,2.79,0,0,1-1.63,2.43l-.77.38c-.26.14-.51.28-.75.43a2.77,2.77,0,0,1-2.91,0l-3.07-1.9-6.18,10,3.06,1.89a2.8,2.8,0,0,1,1.29,2.62,17,17,0,0,0-.06,1.75,2.78,2.78,0,0,1-1.45,2.52l-3.17,1.7,5.54,10.32,3.16-1.69a2.78,2.78,0,0,1,2.91.19,17.44,17.44,0,0,0,1.49.91,2.81,2.81,0,0,1,1.47,2.53l-.11,3.59,11.7.37.12-3.6a2.75,2.75,0,0,1,1.62-2.41l.78-.4.75-.42a2.77,2.77,0,0,1,2.92,0Zm-9.91-7.39a9.6,9.6,0,1,1,3.93-13A9.59,9.59,0,0,1,85.2,200.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.29,225.49l-4.1-7.11L653,219.64a2,2,0,0,1-2-.07,11.27,11.27,0,0,0-1.06-.62,1.93,1.93,0,0,1-1.08-1.73v-2.51h-8.21v2.51a2,2,0,0,1-1.08,1.73,11.43,11.43,0,0,0-1.07.62,2,2,0,0,1-2,.07l-2.18-1.26-4.1,7.11,2.19,1.26a1.93,1.93,0,0,1,.95,1.81c0,.2,0,.4,0,.6s0,.4,0,.6a1.94,1.94,0,0,1-.95,1.81l-2.19,1.26,4.1,7.11,2.19-1.26a1.93,1.93,0,0,1,2,.08c.34.22.7.42,1.06.61a1.94,1.94,0,0,1,1.08,1.73v2.51h8.21V241.1a2,2,0,0,1,1.07-1.73,12.18,12.18,0,0,0,1.06-.61,1.94,1.94,0,0,1,2-.08l2.18,1.26,4.1-7.11-2.18-1.26a1.92,1.92,0,0,1-1-1.8c0-.2,0-.4,0-.61s0-.4,0-.6a1.93,1.93,0,0,1,1-1.81Zm-7.85,3.67a6.72,6.72,0,1,1-6.72-6.72A6.72,6.72,0,0,1,651.44,229.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "663.05 143.48 661.55 143.48 661.55 142.48 662.05 142.48 662.05 141.98 663.05 141.98 663.05 143.48",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.56,143.48h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "591.61 143.48 590.11 143.48 590.11 141.98 591.11 141.98 591.11 142.48 591.61 142.48 591.61 143.48",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.11,140h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1V98h1Zm0-4h-1V94h1Zm0-4h-1V90h1Zm0-4h-1V86h1Zm0-4h-1V82h1Zm0-4h-1V78h1Zm0-4h-1V74h1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "591.11 72.04 590.11 72.04 590.11 70.54 591.61 70.54 591.61 71.54 591.11 71.54 591.11 72.04",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.56,71.54h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "663.05 72.04 662.05 72.04 662.05 71.54 661.55 71.54 661.55 70.54 663.05 70.54 663.05 72.04",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.05,140h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1V98h1Zm0-4h-1V94h1Zm0-4h-1V90h1Zm0-4h-1V86h1Zm0-4h-1V82h1Zm0-4h-1V78h1Zm0-4h-1V74h1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.13,
    y: 138.5,
    width: 8.97,
    height: 8.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.59,148h-10V138h10Zm-9-1h8v-8h-8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.17,
    y: 102.53,
    width: 8.97,
    height: 8.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.59,112h-10V102h10Zm-9-1h8v-8h-8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586.17,
    y: 66.56,
    width: 8.97,
    height: 8.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.59,76h-10v-10h10Zm-9-1h8v-8h-8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.11,
    y: 138.5,
    width: 8.97,
    height: 8.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.54,148h-10V138h10Zm-9-1h8v-8h-8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.11,
    y: 102.53,
    width: 8.97,
    height: 8.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.54,112h-10V102h10Zm-9-1h8v-8h-8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 658.11,
    y: 66.56,
    width: 8.97,
    height: 8.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.54,76h-10v-10h10Zm-9-1h8v-8h-8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622.14,
    y: 66.56,
    width: 8.97,
    height: 8.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.57,76h-10v-10h10Zm-9-1h8v-8h-8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622.1,
    y: 138.5,
    width: 8.97,
    height: 8.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.57,148h-10V138h10Zm-9-1h8v-8h-8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.26 306.87 213.76 306.87 213.76 305.87 214.26 305.87 214.26 305.37 215.26 305.37 215.26 306.87",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.76,306.87h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.81 306.87 142.31 306.87 142.31 305.37 143.31 305.37 143.31 305.87 143.81 305.87 143.81 306.87",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.31,303.37h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.31 235.42 142.31 235.42 142.31 233.92 143.81 233.92 143.81 234.92 143.31 234.92 143.31 235.42",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.76,234.92h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Zm-4,0h-2v-1h2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.26 235.42 214.26 235.42 214.26 234.92 213.76 234.92 213.76 233.92 215.26 233.92 215.26 235.42",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.26,303.37h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Zm0-4h-1v-2h1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.33,
    y: 301.89,
    width: 8.97,
    height: 8.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.8,311.35h-10v-10h10Zm-9-1h8v-8h-8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.37,
    y: 265.91,
    width: 8.97,
    height: 8.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.8,275.38h-10v-10h10Zm-9-1h8v-8h-8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.37,
    y: 229.94,
    width: 8.97,
    height: 8.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.8,239.41h-10v-10h10Zm-9-1h8v-8h-8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.31,
    y: 301.89,
    width: 8.97,
    height: 8.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.74,311.35h-10v-10h10Zm-9-1h8v-8h-8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.31,
    y: 265.91,
    width: 8.97,
    height: 8.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.74,275.38h-10v-10h10Zm-9-1h8v-8h-8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.31,
    y: 229.94,
    width: 8.97,
    height: 8.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.74,239.41h-10v-10h10Zm-9-1h8v-8h-8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.34,
    y: 229.94,
    width: 8.97,
    height: 8.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.77,239.41h-10v-10h10Zm-9-1h8v-8h-8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.3,
    y: 301.89,
    width: 8.97,
    height: 8.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.77,311.35h-10v-10h10Zm-9-1h8v-8h-8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.17,215.53V405.08H238.46Zm34.71,85.89,69,69H84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.17,215.53V405.09H238.45L55.84,222.22l-.84-.85Zm34.71,85.89,69,69H84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 223.53,
    width: 6.51,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 227.75,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 231.95,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 236.17,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 240.38,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 244.58,
    width: 3.83,
    height: 0.92,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 248.8,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 253.01,
    width: 6.51,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 257.23,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 261.43,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 265.64,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 269.86,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 274.06,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 278.27,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 282.49,
    width: 6.51,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 286.69,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 290.9,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 295.12,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 299.32,
    width: 3.83,
    height: 0.92,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 303.53,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 307.75,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 311.97,
    width: 6.51,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 316.17,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 320.38,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 324.6,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 328.8,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 333.01,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 337.23,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 341.43,
    width: 6.51,
    height: 0.92,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 345.64,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 349.86,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 354.07,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 358.27,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 362.49,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 366.7,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 370.9,
    width: 6.51,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 375.12,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 379.33,
    width: 3.83,
    height: 0.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 383.54,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 387.75,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 391.97,
    width: 3.83,
    height: 0.91,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.17,
    y: 396.17,
    width: 3.83,
    height: 0.92,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "46.15 404.94 128.36 404.7 210.57 404.61 375 404.44 539.42 404.61 621.64 404.7 703.85 404.94 621.64 405.19 539.42 405.27 375 405.44 210.57 405.27 128.36 405.19 46.15 404.94",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 373.38,
    cy: 426.32,
    rx: 223.19,
    ry: 18.48,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 375,
    cy: 457.03,
    rx: 162.2,
    ry: 15.86,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bulb--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.76,196.87c-11.3,52.48-47.11,63.81-53.52,79.68-3.69,9.29-8.59,32.92-8.59,32.92l-67.25,0s-4.87-23.62-8.61-32.91c-6.89-17.17-48.29-29-55.79-93.35C272,140.94,303.8,74.16,375,74.13v44.81a8.57,8.57,0,0,1-8.57,8.56,8.78,8.78,0,0,1-6.76-3.32,17.86,17.86,0,1,0,0,22.64,9.29,9.29,0,0,1,3-2.43,8.41,8.41,0,0,1,3.74-.89,8.57,8.57,0,0,1,8.57,8.56v44.81h44.81a8.57,8.57,0,0,0,8.56-8.56,8.75,8.75,0,0,0-3.32-6.76,17.86,17.86,0,1,1,22.64,0,9.15,9.15,0,0,0-2.43,3,8.42,8.42,0,0,0-.89,3.75,8.56,8.56,0,0,0,8.56,8.56Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.76,196.87c-11.3,52.48-47.11,63.81-53.52,79.68-3.69,9.29-8.59,32.92-8.59,32.92H375.14V278.39c.09-2.28-.29-4.63.61-6.7a8.39,8.39,0,0,1,4.61-4.62,8.25,8.25,0,0,1,6.5.13,8.82,8.82,0,0,1,2.71,1.93c.38.4.74.85,1.13,1.29s.8.83,1.23,1.22a18.07,18.07,0,1,0,0-26.8c-.43.38-.83.8-1.23,1.22s-.74.89-1.12,1.29a8.82,8.82,0,0,1-2.72,1.93,8.21,8.21,0,0,1-6.5.13,8.36,8.36,0,0,1-4.61-4.62c-.9-2.07-.53-4.42-.61-6.7V196.87h44.62a8.57,8.57,0,0,0,8.56-8.56,8.75,8.75,0,0,0-3.32-6.76,17.86,17.86,0,1,1,22.64,0,9.15,9.15,0,0,0-2.43,3,8.42,8.42,0,0,0-.89,3.75,8.56,8.56,0,0,0,8.56,8.56Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.92,135.5a17.88,17.88,0,0,0,31.7,11.32,9.29,9.29,0,0,1,3-2.43,8.41,8.41,0,0,1,3.74-.89,8.57,8.57,0,0,1,8.57,8.56v44.62h-.19l-27.29,0H330.3A8.68,8.68,0,0,0,322.2,209a9.3,9.3,0,0,0,2,2.83c.43.4.88.76,1.3,1.13s.82.79,1.2,1.21a17.7,17.7,0,1,1-26.29,0,26.46,26.46,0,0,1,2.49-2.35,8.85,8.85,0,0,0,2-2.81,8.61,8.61,0,0,0-4.66-11.52,9,9,0,0,0-3.39-.63H279.23q-1.38-6.36-2.23-13.56C272,140.94,303.8,74.16,375,74.13v44.81a8.57,8.57,0,0,1-8.57,8.56,8.78,8.78,0,0,1-6.76-3.32,17.88,17.88,0,0,0-31.7,11.32Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.52,
    y: 205.72,
    width: 2,
    height: 106.94,
    transform: "translate(-42.31 69.71) rotate(-10.77)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.07,
    y: 258.18,
    width: 106.94,
    height: 2,
    transform: "translate(72 605.31) rotate(-79.25)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,241c-6.07,0-11.65-5.34-15.61-12.23-1.83,1.92-3.79,2.93-5.73,2.93h0c-10.16,0-15.16-20-15.37-20.82l1.95-.48c0,.19,4.83,19.3,13.42,19.3h0c1.59,0,3.22-1.07,4.71-2.8-3.07-6-4.94-12.8-4.95-18.23,0-5.71,2.24-9,6.16-9h0c4.52,0,7.12,3.47,7.12,9.53a33.45,33.45,0,0,1-3.83,14.53,24,24,0,0,1-2.09,3.36c.19.35.39.7.59,1,4,6.91,9,10.86,13.63,10.86h0c4.27,0,8.53-3.32,12-9.34l.45-.82a18.85,18.85,0,0,1-2.5-3.42c-4-6.85-4.77-17-1.77-22.24a6.33,6.33,0,0,1,5.63-3.5h0a4.93,4.93,0,0,1,4.42,2.69c2.92,5,1.33,16.75-3.32,26.09a9.71,9.71,0,0,0,6.55,2.56h0c6.08,0,11.46-14.06,13-19.47l1.92.55a70.17,70.17,0,0,1-4,10.26C404,229.45,400.3,233,396.5,233h0a11.74,11.74,0,0,1-7.5-2.76c-.08.13-.16.26-.23.4C384.91,237.35,380,241,375,241Zm13.82-39.32h0a4.39,4.39,0,0,0-3.9,2.5c-2.69,4.66-1.88,13.93,1.77,20.24a18,18,0,0,0,1.74,2.51c4-8.51,5.55-19.29,3.08-23.56A3,3,0,0,0,388.84,201.7Zm-29.24,0h0c-3.44,0-4.16,3.8-4.16,7,0,4.76,1.65,10.92,4.32,16.42a31.48,31.48,0,0,0,5-15.87C364.72,205.8,363.83,201.71,359.6,201.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.56,
    y: 309.49,
    width: 82.97,
    height: 16.22,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.57,
    y: 328.33,
    width: 82.97,
    height: 16.21,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.83,62.59a47.31,47.31,0,0,1-.89-6.09q-.29-3-.34-6.09c0-2,0-4.07.11-6.11a47.16,47.16,0,0,1,.67-6.11,46.91,46.91,0,0,1,.89,6.08c.18,2,.3,4.07.33,6.1s0,4.07-.11,6.1A47.1,47.1,0,0,1,373.83,62.59Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.11,78.15a47.25,47.25,0,0,1-3.81-4.83q-1.77-2.5-3.34-5.11c-1.06-1.74-2-3.52-3-5.34a45.75,45.75,0,0,1-2.48-5.63,48.25,48.25,0,0,1,3.81,4.82c1.18,1.67,2.3,3.37,3.34,5.12s2,3.52,3,5.34A47.31,47.31,0,0,1,318.11,78.15Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.64,119.48a48.28,48.28,0,0,1-5.72-2.27q-2.78-1.29-5.45-2.76c-1.78-1-3.52-2-5.23-3.15a46.61,46.61,0,0,1-5-3.63,46.48,46.48,0,0,1,5.71,2.27c1.86.85,3.67,1.77,5.45,2.76s3.52,2,5.23,3.15A46.73,46.73,0,0,1,277.64,119.48Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.25,175.51a48.7,48.7,0,0,1-6.08.89c-2,.18-4.07.3-6.1.33s-4.07,0-6.11-.1a47.16,47.16,0,0,1-6.11-.67,46.91,46.91,0,0,1,6.08-.89c2-.18,4.07-.3,6.1-.33s4.07,0,6.11.1A47.16,47.16,0,0,1,263.25,175.51Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.81,231.23A48.67,48.67,0,0,1,274,235c-1.66,1.17-3.37,2.29-5.11,3.34s-3.52,2-5.34,3a47.31,47.31,0,0,1-5.63,2.48,47.35,47.35,0,0,1,4.83-3.82c1.66-1.17,3.36-2.29,5.11-3.33s3.52-2,5.34-3A45.75,45.75,0,0,1,278.81,231.23Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.36,229.2a48.28,48.28,0,0,1,5.72,2.27c1.85.86,3.67,1.77,5.45,2.76s3.52,2,5.23,3.14a46.71,46.71,0,0,1,5,3.64,48.13,48.13,0,0,1-5.71-2.27c-1.86-.86-3.67-1.77-5.45-2.76s-3.52-2-5.23-3.15A48.16,48.16,0,0,1,472.36,229.2Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.75,173.17a46.91,46.91,0,0,1,6.08-.89q3.06-.28,6.1-.34c2,0,4.07,0,6.11.11a49,49,0,0,1,6.11.66,46.94,46.94,0,0,1-6.08.9c-2,.18-4.07.3-6.1.33s-4.07,0-6.11-.11A49,49,0,0,1,486.75,173.17Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.19,117.45a47.25,47.25,0,0,1,4.83-3.81c1.66-1.18,3.37-2.29,5.11-3.34s3.52-2,5.34-3a45.75,45.75,0,0,1,5.63-2.48,47.25,47.25,0,0,1-4.83,3.81q-2.49,1.77-5.11,3.34c-1.74,1-3.52,2-5.34,3A47.31,47.31,0,0,1,471.19,117.45Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.86,77a48.28,48.28,0,0,1,2.27-5.72c.86-1.85,1.77-3.67,2.76-5.45s2-3.52,3.14-5.23a47.08,47.08,0,0,1,3.64-5,46.48,46.48,0,0,1-2.27,5.71c-.86,1.85-1.77,3.67-2.76,5.45s-2,3.52-3.15,5.23A46.73,46.73,0,0,1,429.86,77Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M470.21,196.67H456.47c-2.28-.09-4.63.29-6.7-.61a8.39,8.39,0,0,1-4.62-4.61,8.25,8.25,0,0,1,.13-6.5,8.82,8.82,0,0,1,1.93-2.71c.4-.38.85-.74,1.29-1.13s.83-.8,1.22-1.23a18.07,18.07,0,1,0-26.8,0c.38.43.8.83,1.22,1.23s.89.74,1.29,1.12a8.82,8.82,0,0,1,1.93,2.72,8.21,8.21,0,0,1,.13,6.5,8.36,8.36,0,0,1-4.62,4.61c-2.07.9-4.42.53-6.7.61H374.76v.38l0,27.29v17.17a8.68,8.68,0,0,0,12.24,8.1,9.3,9.3,0,0,0,2.83-2c.4-.43.76-.88,1.13-1.3s.79-.82,1.21-1.2a17.7,17.7,0,1,1,0,26.29,26.46,26.46,0,0,1-2.35-2.49,8.85,8.85,0,0,0-2.81-2,8.61,8.61,0,0,0-11.52,4.66,9,9,0,0,0-.63,3.39v34.52H375V278.39c.08-2.27-.29-4.63.62-6.75a8.44,8.44,0,0,1,11.27-4.56,9,9,0,0,1,2.75,2,25.4,25.4,0,0,0,2.36,2.51,17.94,17.94,0,1,0,0-26.66c-.43.39-.83.8-1.23,1.22s-.74.88-1.13,1.29a8.89,8.89,0,0,1-2.73,1.94,8.31,8.31,0,0,1-6.56.13,8.45,8.45,0,0,1-4.63-4.65c-.91-2.1-.52-4.46-.61-6.73V224.35l0-27.29H375l.19-.19v.19H419.6a9,9,0,0,0,3.43-.63,8.76,8.76,0,0,0,4.74-11.7,9.39,9.39,0,0,0-2-2.85c-.43-.41-.87-.76-1.29-1.14s-.82-.78-1.2-1.2a17.62,17.62,0,1,1,26.13,0,16.84,16.84,0,0,1-1.19,1.2c-.42.38-.86.73-1.29,1.14a9.32,9.32,0,0,0-2,2.86,8.63,8.63,0,0,0-.12,6.85,8.75,8.75,0,0,0,8.29,5.47h17.68l.09-.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M417.11,245.65a18.16,18.16,0,0,0-25.16-.81c-.43.38-.83.8-1.23,1.22s-.74.89-1.12,1.29a8.82,8.82,0,0,1-2.72,1.93,8.21,8.21,0,0,1-6.5.13,8.36,8.36,0,0,1-4.61-4.62c-.9-2.07-.53-4.42-.61-6.7V196.68h-.38l-27.29,0H330.3A8.68,8.68,0,0,0,322.2,209a9.3,9.3,0,0,0,2,2.83c.43.4.88.76,1.3,1.13s.82.79,1.2,1.21a17.7,17.7,0,1,1-26.29,0,26.46,26.46,0,0,1,2.49-2.35,8.85,8.85,0,0,0,2-2.81,8.61,8.61,0,0,0-4.66-11.52,9,9,0,0,0-3.39-.63H279.23a.45.45,0,0,0,0,.16h14.17c2.27.08,4.63-.29,6.75.62a8.44,8.44,0,0,1,4.56,11.27,9,9,0,0,1-2,2.75,25.4,25.4,0,0,0-2.51,2.36,17.94,17.94,0,1,0,26.66,0c-.39-.43-.8-.83-1.22-1.23s-.88-.74-1.29-1.13a8.89,8.89,0,0,1-1.94-2.73,8.31,8.31,0,0,1-.13-6.56,8.45,8.45,0,0,1,4.65-4.63c2.1-.91,4.46-.52,6.73-.61h13.74l27.29,0v-.19l.19.19h-.19v44.46a9,9,0,0,0,.63,3.43,8.76,8.76,0,0,0,11.7,4.74,9.39,9.39,0,0,0,2.85-2c.41-.43.76-.87,1.14-1.29s.78-.82,1.2-1.2a17.62,17.62,0,1,1,0,26.13,16.84,16.84,0,0,1-1.2-1.19c-.38-.42-.73-.86-1.14-1.29a9.32,9.32,0,0,0-2.86-2,8.63,8.63,0,0,0-6.85-.12,8.75,8.75,0,0,0-5.47,8.29v34.52h.38V278.39c.09-2.28-.29-4.63.61-6.7a8.39,8.39,0,0,1,4.61-4.62,8.25,8.25,0,0,1,6.5.13,8.82,8.82,0,0,1,2.71,1.93c.38.4.74.85,1.13,1.29s.8.83,1.23,1.22a18.09,18.09,0,0,0,25.16-26Zm-.27.27a17.78,17.78,0,0,0-24.64-.81c-.42.38-.82.79-1.21,1.2s-.73.87-1.13,1.3a9.3,9.3,0,0,1-2.83,2,8.64,8.64,0,0,1-6.8.14,8.72,8.72,0,0,1-5.44-8.24V224.35l0-27.29v44.46a9,9,0,0,0,.63,3.43,8.76,8.76,0,0,0,11.7,4.74,9.39,9.39,0,0,0,2.85-2c.41-.43.76-.87,1.14-1.29s.78-.82,1.2-1.2a17.62,17.62,0,1,1,0,26.13,16.84,16.84,0,0,1-1.2-1.19c-.38-.42-.73-.86-1.14-1.29a9.32,9.32,0,0,0-2.86-2,8.63,8.63,0,0,0-6.85-.12,8.75,8.75,0,0,0-5.47,8.29v34.52h.12V275a9,9,0,0,1,.63-3.39A8.61,8.61,0,0,1,387,266.91a8.85,8.85,0,0,1,2.81,2,26.46,26.46,0,0,0,2.35,2.49,17.74,17.74,0,0,0,24.67-25.48Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M371.41,74.19h3.48v-.06Q373.14,74.13,371.41,74.19Zm3.71,95.2V152.22a8.68,8.68,0,0,0-12.24-8.1,9.3,9.3,0,0,0-2.83,2c-.4.43-.76.88-1.13,1.3s-.79.82-1.21,1.2a17.7,17.7,0,1,1,0-26.29,26.46,26.46,0,0,1,2.35,2.49,8.85,8.85,0,0,0,2.81,2,8.61,8.61,0,0,0,11.52-4.66,9,9,0,0,0,.63-3.39V101.61l0-27.48h-.12l.06.06h-.06l0,27.42v13.74c-.08,2.27.29,4.63-.62,6.75A8.44,8.44,0,0,1,363,126.66a9,9,0,0,1-2.75-2,25.4,25.4,0,0,0-2.36-2.51,17.94,17.94,0,1,0,0,26.66c.43-.39.83-.8,1.23-1.22s.74-.88,1.13-1.29A8.89,8.89,0,0,1,363,144.4a8.31,8.31,0,0,1,6.56-.13,8.45,8.45,0,0,1,4.63,4.65c.91,2.1.52,4.46.61,6.73v13.74l0,27.29H375l-.19.19v-.19H330.3a9,9,0,0,0-3.43.63,8.76,8.76,0,0,0-4.74,11.7,9.39,9.39,0,0,0,2,2.85c.43.41.87.76,1.29,1.14s.82.78,1.2,1.2a17.62,17.62,0,1,1-26.13,0,16.84,16.84,0,0,1,1.19-1.2c.42-.38.86-.73,1.29-1.14a9.32,9.32,0,0,0,2-2.86,8.63,8.63,0,0,0,.12-6.85,8.75,8.75,0,0,0-8.29-5.47H279.2a.27.27,0,0,0,0,.12.45.45,0,0,0,0,.16.27.27,0,0,0,0,.12h14.14c2.28.09,4.63-.29,6.7.61a8.39,8.39,0,0,1,4.62,4.61,8.25,8.25,0,0,1-.13,6.5,8.82,8.82,0,0,1-1.93,2.71c-.4.38-.85.74-1.29,1.13s-.83.8-1.22,1.23a18.07,18.07,0,1,0,26.8,0c-.38-.43-.8-.83-1.22-1.23s-.89-.74-1.29-1.12a8.82,8.82,0,0,1-1.93-2.72,8.21,8.21,0,0,1-.13-6.5,8.36,8.36,0,0,1,4.62-4.61c2.07-.9,4.42-.53,6.7-.61h41.41v-.38Zm-27.65,27.28H330.3a9,9,0,0,0-3.43.63,8.76,8.76,0,0,0-4.74,11.7,9.39,9.39,0,0,0,2,2.85c.43.41.87.76,1.29,1.14s.82.78,1.2,1.2a17.62,17.62,0,1,1-26.13,0,16.84,16.84,0,0,1,1.19-1.2c.42-.38.86-.73,1.29-1.14a9.32,9.32,0,0,0,2-2.86,8.63,8.63,0,0,0,.12-6.85,8.75,8.75,0,0,0-8.29-5.47H279.2a.27.27,0,0,0,0,.12h17.63a9,9,0,0,1,3.39.63,8.61,8.61,0,0,1,4.66,11.52,8.85,8.85,0,0,1-2,2.81,26.46,26.46,0,0,0-2.49,2.35,17.73,17.73,0,1,0,26.29,0c-.38-.42-.79-.82-1.2-1.21s-.87-.73-1.3-1.13a9.3,9.3,0,0,1-2-2.83,8.64,8.64,0,0,1-.14-6.8,8.72,8.72,0,0,1,8.24-5.44h17.17l27.29,0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M579.5,150.38c-6,2.85-26.91,8.25-35.62,2.43-7.8-5.21-8.46-42.58-5.2-54.56,1.14-4.21,17.75,3.85,19.51,7.39,1.51,3-1,31.25.25,31.87,2,1,8.61,1.82,19.11,3.29C587.43,142.18,583.71,148.37,579.5,150.38Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.61,118,536.4,107.49s-3.82,38.05,7,46.07c2.5,1.85,19.15,4.92,34.83-1.79,4.85-2.08,12.39-9.25-2-11.53s-17.05-3.09-17.31-3.44S558.61,118,558.61,118Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M547.92,126.27a1.93,1.93,0,0,0,2.63-.23c1.28-1.44.66-3.89,0-5.52s-1.82-3.39-3.72-3.69a1.51,1.51,0,0,0-1.67,2c.26,1.26.92,2.41,1.24,3.66S546.69,125.37,547.92,126.27Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M550.11,133.92c1.12-.6,1.31-2.22,1.3-3.35a3.2,3.2,0,0,0-.51-1.72,1.6,1.6,0,0,0-2.18-.58,2.09,2.09,0,0,0-.8,1.36,4.48,4.48,0,0,0-.1.82v.16a5.23,5.23,0,0,0-.14,2.51A1.64,1.64,0,0,0,550.11,133.92Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M556.11,131.33a10.22,10.22,0,0,0,.5-6.23c-.32-1.66-1-4.38-2.86-4.81a1,1,0,0,0-1,.54c-.76,1.24,0,3.4.14,4.76.15,1.72,0,3.45.16,5.17A1.65,1.65,0,0,0,556.11,131.33Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M545.57,139.9a2.18,2.18,0,0,0,.87.41,2,2,0,0,0,1.41-.3,3.11,3.11,0,0,0,1-1.18,2.89,2.89,0,0,0,.28-1.42L549,137l-.21-.42a1.77,1.77,0,0,0-2.78-.13,8.83,8.83,0,0,0-1,1.23l-.15.46a1.46,1.46,0,0,0,0,.72A1.78,1.78,0,0,0,545.57,139.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M551.42,139.35a1.58,1.58,0,0,0,1.83-.41,3.94,3.94,0,0,0,.8-1.85,3.49,3.49,0,0,0-.06-1.87,1.22,1.22,0,0,0-2.07-.38,6.1,6.1,0,0,0-.7,1.34c-.1.2-.21.39-.32.58a5,5,0,0,0-.34.91A1.56,1.56,0,0,0,551.42,139.35Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M537,113.19c1.84.58,3.62,1.43,5.39,2.19s3.5,1.52,5.24,2.3c3.51,1.56,7.09,3.06,10.49,4.85a.07.07,0,0,1,0,.13c-3.68-1.22-7.25-2.84-10.8-4.39q-2.67-1.17-5.31-2.42a48.5,48.5,0,0,1-5-2.54C536.87,113.27,536.94,113.16,537,113.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.25,151.77c-15.68,6.71-32.33,3.64-34.82,1.79-5-3.72-6.9-13.9-7.47-23.75L558.78,135a10.39,10.39,0,0,0,.13,1.84c.26.36,2.88,1.16,17.3,3.44S583.1,149.69,578.25,151.77Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.9,406c1.88.62,55.64.47,57.68-.83.78-.49,1.21-8.33,1.47-17.8.05-2,.1-4.15.13-6.31,0-2.54.07-5.11.09-7.61.07-11.23-.09-21.11-.09-21.11h-35V381l.18,6.31s-20.55,9.27-22.64,10.94S523,405.35,524.9,406Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.9,406c1.88.62,55.64.47,57.68-.83.78-.49,1.21-8.33,1.47-17.8.05-2,.1-4.15.13-6.31,0-2.54.07-5.11.09-7.61H549.2V381l.18,6.31s-20.55,9.27-22.64,10.94S523,405.35,524.9,406Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.74,406.05c1.22.4,24.12.48,40.79.14,3.86-.08,7.38-.19,10.23-.32,3.92-.18,6.55-.39,7-.66,1-.61,1.4-12.11,1.61-24.24H549.19l.18,6.34s-20.67,9.32-22.77,11S522.86,405.41,524.74,406.05Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.51,403.88c9.06-.25,45.62-.39,54.6.05.07,0,.07.05,0,.06-9,.44-45.54.29-54.6,0C525.32,404,525.32,403.89,525.51,403.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.08,385.31c3.57-.68,7.93-.15,10.66,2.39.11.1,0,.24-.15.21a50,50,0,0,0-10.49-2.15A.23.23,0,0,1,548.08,385.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.51,386.86c3.57-.67,7.93-.14,10.66,2.4.11.09,0,.24-.15.21a50.65,50.65,0,0,0-10.49-2.16A.23.23,0,0,1,545.51,386.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543,388.42c3.56-.67,7.92-.14,10.65,2.39.11.1,0,.25-.15.21A50.63,50.63,0,0,0,543,388.87.23.23,0,0,1,543,388.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.38,390c3.56-.67,7.92-.14,10.65,2.39.11.1,0,.25-.15.21a49.86,49.86,0,0,0-10.49-2.15A.23.23,0,0,1,540.38,390Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.09,382.15c2.52,2,5.81,2.75,8.76,3.83a.44.44,0,0,0,.55-.45.1.1,0,0,0,.09-.13,19,19,0,0,0-5.52-8.15c-1.49-1.24-4.1-2.1-5.5-.17S541.61,381,543.09,382.15Zm-.92-2.86c-.64-3.91,3.57-1.87,4.63-.91a21.63,21.63,0,0,1,1.9,2,55.09,55.09,0,0,1,3.32,4.69c-1.41-.62-2.87-1.12-4.31-1.68C546,382.75,542.52,381.44,542.17,379.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.38,379.94c-.87-2.22-3.62-2-5.37-1.21a19,19,0,0,0-7.38,6.52.09.09,0,0,0,0,.14.45.45,0,0,0,.43.58c3.12-.32,6.5-.26,9.44-1.52C563.26,383.71,565.2,382,564.38,379.94Zm-7.63,4.58c-1.53.2-3.07.31-4.59.56a55.52,55.52,0,0,1,4.39-3.71,20.63,20.63,0,0,1,2.34-1.5c1.27-.67,5.86-1.6,4.26,2C562.27,383.9,558.58,384.3,556.75,384.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.85,203.18s-9.46,93.54-9.68,94.73c0,.15-.1,1.95-.19,4.89-.51,16.1-1.77,66.31-1.77,66.31H545.63s2.51-59.47,4-73.34c1.84-17.7,13.46-92.59,13.46-92.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.57,301.2q1.78-30.39,5.37-60.65c1.35-11.37,3-22.69,4.6-34,0-.1.17-.1.16,0-3,20.17-5.1,40.49-6.93,60.78s-3.09,40.6-3.92,60.93c-.47,11.53-.82,23.06-1.19,34.58a.22.22,0,0,1-.43,0C579.77,342.27,580.36,321.72,581.57,301.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.06,362.89c1-.13,2.11-.09,3.14-.12s2.32,0,3.47-.1c2.24-.08,4.47-.14,6.71-.18,4.5-.07,9,0,13.52.1l3.72.13c1.32,0,2.64.17,4,.16.1,0,.1.12,0,.12-2.27,0-4.57.2-6.84.28s-4.46.12-6.7.15c-4.5.06-9,0-13.52-.14-1.24-.05-2.48-.06-3.72-.1l-2-.09c-.59,0-1.18,0-1.76-.05A.08.08,0,0,1,548.06,362.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.85,203.18s-9.46,93.54-9.68,94.73c0,.15-.1,1.95-.19,4.89l-18.19-99.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.05,404.3c2-.21,50.87-22.53,52.2-24.56.51-.76-2.33-8.08-6-16.81-.79-1.89-1.53-3.88-2.48-5.8-1.18-2.42-2.39-4.84-3.59-7.15-5.16-10-9.9-18.28-9.9-18.28l-31,14L633.24,364l3.67,7.52,2.76,5.66s-14.89,16.93-16.11,19.31S623.09,404.51,625.05,404.3Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.05,404.3c2-.21,50.87-22.53,52.2-24.56.51-.76-2.33-8.08-6-16.81-.79-1.89-1.53-3.88-2.48-5.8-1.18-2.42-2.39-4.84-3.59-7.15-9.56,4.28-23.34,10.32-31.93,14.06l3.67,7.52,2.76,5.66s-14.89,16.93-16.11,19.31S623.09,404.51,625.05,404.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.94,404.44c2-.21,51.15-22.66,52.48-24.7.62-.94-3.72-11.6-8.53-22.74l-32,14.51,2.78,5.7s-15,17-16.21,19.41S623,404.65,624.94,404.44Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.74,402.15c8.15-4,41.4-19.19,49.76-22.49.07,0,.09,0,0,.06-8,4.1-41.36,19-49.72,22.56C624.63,402.36,624.57,402.23,624.74,402.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.64,375.91c3-2.08,7.16-3.4,10.7-2.22.13.05.07.24-.05.26a50.06,50.06,0,0,0-10.45,2.37A.23.23,0,0,1,637.64,375.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636,378.39c3-2.08,7.16-3.4,10.69-2.22.14.05.07.24,0,.26a49.94,49.94,0,0,0-10.44,2.36A.23.23,0,0,1,636,378.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.25,380.87c3-2.09,7.16-3.4,10.69-2.22.14.05.07.24-.05.26a49.94,49.94,0,0,0-10.44,2.36A.23.23,0,0,1,634.25,380.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.55,383.35c3-2.09,7.16-3.4,10.7-2.22.13.05.07.24,0,.26a49.89,49.89,0,0,0-10.45,2.36A.23.23,0,0,1,632.55,383.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.79,375.1c3.11.74,6.43.1,9.56-.13a.43.43,0,0,0,.32-.63.11.11,0,0,0,0-.16,19.19,19.19,0,0,0-8.39-5.15c-1.87-.52-4.61-.22-5.08,2.11S630,374.67,631.79,375.1Zm-2-2.23c-2.19-3.3,2.48-3.18,3.85-2.74a20.43,20.43,0,0,1,2.56,1.08,53.65,53.65,0,0,1,5,2.9c-1.55,0-3.08.17-4.62.24C634.69,374.44,631,374.69,629.77,372.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.27,364.3c-1.71-1.67-4.13-.37-5.39,1.12a19,19,0,0,0-4,9,.1.1,0,0,0,.11.12.44.44,0,0,0,.62.34c2.72-1.57,5.82-2.92,8-5.28C650.81,368.2,651.88,365.87,650.27,364.3Zm-5.06,7.32c-1.31.81-2.66,1.55-4,2.4a56,56,0,0,1,2.47-5.19,19,19,0,0,1,1.52-2.33c.88-1.13,4.67-3.87,4.71.09C650,368.78,646.78,370.66,645.21,371.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.05,203.18s2.54,13.52,12,20.39c0,0,20.79,69.55,23.49,77.53,4.65,13.74,29.67,60.3,29.67,60.3l38.61-16.57S637.33,293,634.15,289c-2.11-2.65-17.74-59-17.77-60.49-.33-16.56-5.89-25.37-5.89-25.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.28,208.08a13,13,0,0,0,4.73,6.78,16,16,0,0,0,8.57,2.94c.52,0,.56.83,0,.83-6.29,0-12.65-4-13.57-10.51C594,208,594.25,207.94,594.28,208.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569,219.29a34.61,34.61,0,0,1,6.5,3.45c2.16,1.33,4.15,2.9,6.24,4.34.08.06,0,.19-.08.14-2.18-1.26-4.46-2.35-6.63-3.65a41.51,41.51,0,0,1-6.13-4.11C568.81,219.4,568.88,219.25,569,219.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.09,206.17c.34,1.44.76,2.87,1.14,4.3s.63,2.71,1,4a7,7,0,0,0,2.06,3.33c.55.47,1.16.88,1.75,1.3.31.23.65.45,1,.69-.05-.19-.09-.39-.13-.58-.13-.55-.24-1.1-.36-1.64-.26-1.22-.52-2.44-.76-3.66-.48-2.39-.93-4.81-1.54-7.18,0-.09.12-.14.15,0,.71,2.34,1.48,4.65,2.11,7,.31,1.16,1.49,6.9,1.55,7.3s.11.84.15,1.27a5.1,5.1,0,0,1,.06,1.29.11.11,0,0,1-.2,0h0a5.36,5.36,0,0,1-.43-1.24c-.12-.41-.24-.82-.33-1.24l-.09-.46c-.58-.32-1.13-.75-1.68-1.11s-1.2-.77-1.76-1.2a6.47,6.47,0,0,1-2.22-3.15,22.2,22.2,0,0,1-.87-4.12c-.26-1.63-.47-3.28-.78-4.9C567.93,206.12,568.07,206.07,568.09,206.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.06,353.61c.88-.53,10-4.78,12-5.72,4.09-1.87,18.24-7.67,19.57-8.16.44-.16.47.08.13.25-2.09,1-10.27,4.77-12.31,5.7-4.1,1.86-18.8,7.9-19.37,8.07A.08.08,0,0,1,628.06,353.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608,204.77a32,32,0,0,1,5.34,17.2,26.89,26.89,0,0,1-.33,4.57c-.06.38-.11.76-.19,1.13l-.12.57a1.35,1.35,0,0,0-.07.47c.09.7.28,1.46.44,2.19.7,2.94,1.48,5.88,2.25,8.8,3.15,11.71,6.33,23.42,9.68,35.07l2.52,8.73c.43,1.45.87,2.9,1.33,4.34.23.71.46,1.45.73,2.11s.64,1.33,1,2c2.86,5.33,5.95,10.56,8.93,15.83,0,0,15.22,25.57,18.35,31.46.14.27.07.45-.21.08-2.72-3.54-12.63-20.71-18.81-31.15-3.09-5.22-6.14-10.45-9.06-15.79-.38-.66-.71-1.36-1.06-2.06s-.53-1.45-.77-2.18c-.47-1.45-.92-2.9-1.36-4.35q-1.3-4.36-2.55-8.74c-3.27-11.69-6.49-23.38-9.44-35.15-.74-2.95-1.47-5.89-2.12-8.86a22.81,22.81,0,0,1-.42-2.27,1.91,1.91,0,0,1,.09-.65l.12-.55c.09-.36.14-.73.21-1.1a29.27,29.27,0,0,0,.4-4.49A32.11,32.11,0,0,0,608,204.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.19,171.54q-2.33,7-5,13l-17.51-3.64A8.56,8.56,0,0,1,529,170.74a8.44,8.44,0,0,1,1.63-3.49,9.17,9.17,0,0,1,3-2.45,17.87,17.87,0,1,0-22.17-4.6,8.77,8.77,0,0,1,1.88,7.29,8.56,8.56,0,0,1-10.13,6.64L459.38,165l9.1-43.88A8.56,8.56,0,0,0,461.83,111a8.43,8.43,0,0,0-3.84.11,9.37,9.37,0,0,0-3.45,1.77,17.86,17.86,0,1,1,4.6-22.17,8.76,8.76,0,0,0,5.94,4.62,8.55,8.55,0,0,0,10.13-6.64l9.11-43.87h.05c19.82,4.11,35.42,12.87,47.29,24.23A95.9,95.9,0,0,1,552,97.55C563.81,122.58,565,151.08,558.19,171.54Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.63,208.47l-53.71.36c0,1.06,2.71-42.09,16.49-67.55.94-1.73,9.37-3.65,13.11-.24C605.93,156,613.63,209.15,613.63,208.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M575.83,196.16a2.43,2.43,0,0,0-4,1c-.69,2.12.69,4.19,2.53,5.19a7,7,0,0,0,6.27.25c1.89-.85,1.37-3.8-.49-4.3a15.1,15.1,0,0,1-2.67-.66C576.77,197.3,576.4,196.63,575.83,196.16Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M573.47,189.14c-1.1,3.19,3.6,6.64,6.41,5.22a1.74,1.74,0,0,0,.41-2.71c-.68-.71-1.3-.89-1.91-1.53a3.13,3.13,0,0,1-.53-.73,4.67,4.67,0,0,0-1.27-1.46A2.12,2.12,0,0,0,573.47,189.14Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M565.37,188.29c-1.21,1.22-.68,3.37.07,4.71a4.2,4.2,0,0,0,3.55,2.32,1.42,1.42,0,0,0,1-2.37,4.24,4.24,0,0,1-1.13-1.85c-.33-1.07-.47-2.43-1.55-3A1.67,1.67,0,0,0,565.37,188.29Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M585.56,194.37a1.6,1.6,0,0,0-1.59,1.56,1.88,1.88,0,0,0,1.56,1.82,2.85,2.85,0,0,0,1.8-.2,1.33,1.33,0,0,0,.62-.7,1.42,1.42,0,0,0,.09-.95,1.52,1.52,0,0,0-1.32-1.1,1.92,1.92,0,0,0-.21-.16A1.78,1.78,0,0,0,585.56,194.37Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M569.17,180.73c-1.26,1.64-.25,4.91,1.49,5.85a1.55,1.55,0,0,0,2.32-1.29,6.91,6.91,0,0,0-.1-1c0-.36-.12-.59-.13-.81a7.92,7.92,0,0,0-.19-2.23A1.89,1.89,0,0,0,569.17,180.73Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M564.56,197.87c-1.7,2.57,2,6.21,4.61,6,.86-.07,1.81-1.07,1.16-2-.52-.71-1.17-1.31-1.64-2-.57-.9-.81-2-1.83-2.55A1.71,1.71,0,0,0,564.56,197.87Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M604.09,193a5.13,5.13,0,0,1-.72,2.66,12.05,12.05,0,0,0-1.84,2.37,1.27,1.27,0,0,0,1.36,1.7,6.07,6.07,0,0,0,4.53-6.8A1.69,1.69,0,0,0,604.09,193Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M600.17,185c-.35,1.23-.1,2.53-.36,3.8a31.19,31.19,0,0,1-.88,3.42c-.27.8.59,1.94,1.48,1.42a6.48,6.48,0,0,0,3.1-3.59c.5-1.42,1-3.76.15-5.12S600.67,183.27,600.17,185Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M596.66,197.27a7.78,7.78,0,0,1-2.41,2.5,1.85,1.85,0,1,0,1.89,3.14,6.65,6.65,0,0,0,3.23-4.6A1.51,1.51,0,0,0,596.66,197.27Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M582.89,158.79a1.91,1.91,0,0,0,2.06-1.65c.27-1.9-1.6-3.6-3-4.6s-3.39-1.82-5.14-1a1.51,1.51,0,0,0-.32,2.55c.92.9,2.11,1.49,3.07,2.36S581.37,158.72,582.89,158.79Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M589,164c.59-1.12-.14-2.57-.77-3.51a3.22,3.22,0,0,0-1.38-1.15,1.6,1.6,0,0,0-2.14.73,2.13,2.13,0,0,0,.08,1.57c.11.26.24.48.38.74l0,.07,0,.07a5.18,5.18,0,0,0,1.27,2.17A1.65,1.65,0,0,0,589,164Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M592.51,158.47a10.23,10.23,0,0,0-3-5.46c-1.19-1.2-3.21-3.12-5-2.42a1,1,0,0,0-.57,1c0,1.46,1.89,2.82,2.74,3.89,1.07,1.35,1.9,2.89,3,4.22A1.65,1.65,0,0,0,592.51,158.47Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M588.47,171.45a2.18,2.18,0,0,0,.95-.15,1.92,1.92,0,0,0,1-1,3,3,0,0,0,.16-1.52,2.88,2.88,0,0,0-.55-1.34l-.32-.31-.41-.24a1.72,1.72,0,0,0-1.12,0,1.76,1.76,0,0,0-1.26,1.47,9,9,0,0,0-.12,1.56l.13.46a1.39,1.39,0,0,0,.42.59A1.81,1.81,0,0,0,588.47,171.45Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M593,167.75a1.58,1.58,0,0,0,1.3-1.35,3.77,3.77,0,0,0-.36-2,3.3,3.3,0,0,0-1.09-1.53,1.22,1.22,0,0,0-1.93.82,6,6,0,0,0,.16,1.52c0,.21,0,.43.06.65a4,4,0,0,0,.22,1A1.55,1.55,0,0,0,593,167.75Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M587.73,154.58c-3.34,7.18-18.73,34.49-29.14,35.59C546,191.49,530,188.68,523,185.27c-3.92-1.91,6.27-21.08,10-19.81,5.9,2,17.37,3,19.65,3.17s18.2-11.91,27.07-18.54C587.67,144.13,589.7,150.35,587.73,154.58Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.44,165.11c1.39-.05,1.37-.78-.63-2.23s-11.16-5.5-9.48-8.57,14.51,2.81,17.66,5.48a64.94,64.94,0,0,1,7.31,8.1C532.57,167.24,525.81,166.31,520.44,165.11Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.75,187.31c-7.83-2-17.6-4.22-23.81-10.62a4.44,4.44,0,0,1-1.28-2.59c-2.84-2.82-2.36-5-2.36-5-1.83-3.43-1-5.6-1-5.6s-3.29-3.35-1.6-5.67c1.89-2.61,6.14,2.6,10.23,4,9.37,3.29,23.61,5.35,26.4,6Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.3,172.21a65,65,0,0,1-8-3.34,65.08,65.08,0,0,1-7.87-5.38c-.08-.06-.18,0-.11.11a33.83,33.83,0,0,0,16,8.74C516.39,172.37,516.43,172.26,516.3,172.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.13,178.15C512.52,177,508,175,501.37,169c0,0-.07,0,0,0a30.28,30.28,0,0,0,13.75,9.22C515.25,178.34,515.31,178.23,515.13,178.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.45,181.34a47.76,47.76,0,0,1-10.77-7.24s-.06,0,0,0c4.06,4.15,6,5.19,10.75,7.36C514.56,181.57,514.62,181.42,514.45,181.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.74,165.54l-8.58,23.76s22.4,4.71,31.38,1.34,20.86-21,26.48-31.35,2.66-19-11.8-7.48-21.44,15.92-22.45,16.13S537.74,165.54,537.74,165.54Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M558.56,185.14a5.26,5.26,0,0,1-2.62.86,12,12,0,0,0-3-.23,1.26,1.26,0,0,0-.66,2.07,6,6,0,0,0,8.16,0A1.68,1.68,0,0,0,558.56,185.14Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M563,177.48c-1.21.38-2.17,1.31-3.37,1.79a28.48,28.48,0,0,1-3.33,1.15c-.82.22-1.3,1.57-.37,2a6.46,6.46,0,0,0,4.7.61c1.46-.37,3.66-1.28,4.36-2.7S564.78,176.92,563,177.48Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M550.88,181.3a7.78,7.78,0,0,1-3.41-.63,1.84,1.84,0,1,0-1.57,3.3,6.6,6.6,0,0,0,5.61.16A1.51,1.51,0,0,0,550.88,181.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M582.89,158.79a1.91,1.91,0,0,0,2.06-1.65c.27-1.9-1.6-3.6-3-4.6s-3.39-1.82-5.14-1a1.51,1.51,0,0,0-.32,2.55c.92.9,2.11,1.49,3.07,2.36S581.37,158.72,582.89,158.79Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M587,159.38c-.53,1-1.12,2-1.76,3.11,0,0,0,0,0,0a.36.36,0,0,1,0-.07l0-.07c-.14-.26-.27-.48-.38-.74a2.13,2.13,0,0,1-.08-1.57,1.6,1.6,0,0,1,2.14-.73A.7.7,0,0,1,587,159.38Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M589.44,153a20.62,20.62,0,0,1-1.48,4.44c-.43-.65-.87-1.3-1.35-1.91-.85-1.07-2.69-2.43-2.74-3.89a1,1,0,0,1,.57-1C586.25,149.9,588.25,151.77,589.44,153Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M562.06,190c.74-1,5.47-2.36,18.11-19.21,2.57-3.44,4.6-6.88,7.15-10.13,0-.05.08,0,.06,0-1.23,2.35-2.61,4.62-4.06,6.84l.33-.28c1-.83,1.94-1.62,2.81-2.53.06-.07.16,0,.09.1-.89.88-1.69,1.84-2.56,2.73-.42.44-.84.87-1.29,1.27l-.55.47c-13.54,18.88-19.34,20-20,20.79C562.1,190.12,562,190,562.06,190Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.25,189.31a57.63,57.63,0,0,1,1.79-5.54q.93-2.7,1.89-5.4c1.3-3.62,2.53-7.29,4.06-10.82a.07.07,0,0,1,.14,0c-1,3.76-2.29,7.44-3.58,11.1-.64,1.83-1.32,3.66-2,5.47a51.64,51.64,0,0,1-2.16,5.22C534.34,189.46,534.23,189.39,534.25,189.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.67,165.31c2.23.22,11.09,2,13.32,2.18a4.54,4.54,0,0,0,2.86-.59c1-.54,17-11.67,18.76-13,.07,0,.16.06.09.11-1.86,1.32-14.3,10.76-16.21,12.09a21.87,21.87,0,0,1-2.66,1.71,4.23,4.23,0,0,1-2.8.32c-2.11-.42-10.32-2-13.2-2.5-.06,0-.48,1-.53,1l-.12,0A4.81,4.81,0,0,1,537.67,165.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.94,115.42c.64-3.64,3.39-8.69,3-11.41a3.15,3.15,0,0,0-2.57-2.74s2.26-2,1.49-4.43c-.4-1.24-2.73-1.68-2.73-1.68a3.77,3.77,0,0,0,.92-3.8c-.65-1.67-2.88-1.87-2.88-1.87s.9-2.41-.31-3.9c-2.46-3-17.29,1.07-18.08,7.16C538.4,95.59,542,94.4,542,94.4s-4.72,3-4,6,5.31,1.24,5.31,1.24-4.55,2.91-3.43,6,5.39.63,5.39.63-2.69,3.15-1.29,5.33c2.31,3.62,7.19-3.07,10.66-3.19l3.28,4.88Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.63,109.93c-.31,3.49,4.7,6.33,4.89,9.71.25,4.58-5.78,1.69-8.59-4.29l-1.37-5Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.82,89.31a0,0,0,0,0,0-.08,26.71,26.71,0,0,0-15,5.12c-.13.11,0,.37.15.29A54.74,54.74,0,0,1,556.82,89.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.18,95.1c.06,0,0-.1,0-.1a25,25,0,0,0-16,6.6c-.15.14-.14.42,0,.27C546.26,99.26,554.29,96,559.18,95.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.06,108.74c4.32-3.91,9.47-6,15.07-7.47.08,0,0-.12,0-.12-2.93-.05-6.41,1.23-9,2.46a15.37,15.37,0,0,0-6.16,5C544.86,108.68,545,108.82,545.06,108.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.74,148.53c2.56.59,7.87-2.46,9.67-6.13.12-.25-.37-2.82-.82-6-.27-1.92-.52-4.05-.61-6,0-.4-12.2,3.55-12.2,3.55a31.26,31.26,0,0,1,1.53,7.5,4.3,4.3,0,0,1,0,.81s0,.08,0,.13C575.07,144,575,147.9,577.74,148.53Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.26,142.27s0,.08,0,.13a7.62,7.62,0,0,0,1.27,0c7.25-.49,8.76-9.66,9-12-2.17.42-11.76,3.53-11.76,3.53a31.26,31.26,0,0,1,1.53,7.5A3.6,3.6,0,0,1,575.26,142.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.58,115c1.39,4.36-.75,17-3.83,19.89-4.46,4.15-11.84,4.64-15.38-.74-3.44-5.22-.35-21.68,3.09-24.29C576.54,106,585.52,108.56,587.58,115Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.35,122.73s.06,0,0,.09c-.17.85-.22,1.85.51,2.26,0,0,0,0,0,0C575,124.84,575.05,123.51,575.35,122.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.26,122c1.39.12,1,2.9-.25,2.79S575.09,121.86,576.26,122Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.36,122.25s-.08,0-.08.07c-.08.86-.32,1.84-1.13,2,0,0,0,0,0,0C570.12,124.38,570.42,123.08,570.36,122.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.7,121.26c-1.37-.28-1.82,2.48-.55,2.74S570.85,121.49,569.7,121.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.51,120.83a9.85,9.85,0,0,1-1-.51,1.9,1.9,0,0,1-1-.72.59.59,0,0,1,.19-.7,1.45,1.45,0,0,1,1.48,0,2.18,2.18,0,0,1,1.12,1.08A.63.63,0,0,1,577.51,120.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.8,119.73a11.12,11.12,0,0,0,1.14-.15,1.89,1.89,0,0,0,1.13-.37.6.6,0,0,0,.06-.72,1.49,1.49,0,0,0-1.42-.46,2.17,2.17,0,0,0-1.41.66A.63.63,0,0,0,568.8,119.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.15,130.8c-.23.18-.47.43-.79.42a2.24,2.24,0,0,1-.89-.33,0,0,0,0,0-.05,0,1.2,1.2,0,0,0,1,.6.93.93,0,0,0,.77-.68S575.18,130.78,575.15,130.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.57,128.12a3,3,0,0,1-2.12,1.06,3.8,3.8,0,0,1-1.06-.09l-.2,0L571,129c-.1,0-.14-.11-.15-.21h0s0-.05,0-.08h0v-.07c.07-.67.26-1.67.26-1.67-.26.09-1.56.5-1.5.15a44.24,44.24,0,0,1,2.24-8.71.08.08,0,0,1,.15,0c-.4,2.75-1.28,5.41-1.72,8.17a5.19,5.19,0,0,1,1.43-.25c.09,0-.4,1.92-.4,2.22v0a4.07,4.07,0,0,0,3.15-.56C574.57,128,574.63,128.06,574.57,128.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.82,128.81a3.54,3.54,0,0,0,1.26,1.25,1.58,1.58,0,0,0,.94.17c.71-.09.81-.72.75-1.27a3.68,3.68,0,0,0-.21-.86A4.55,4.55,0,0,1,571.82,128.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.08,130.06a1.58,1.58,0,0,0,.94.17c.71-.09.81-.72.75-1.27A1.62,1.62,0,0,0,573.08,130.06Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.11,113.84c.6-1,1.28-2.06,2-2.2s.92,1.52,2.4,1.8c2,.39,3.21-1.34,6-1.19,4.08.21,5.45,3.81,4.84,9.57-.54,5.14,2.5,6,2.5,6s3.27-11.09.54-15.23-9.84-6.69-15.2-3.72C570.25,110,569.11,113.84,569.11,113.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.52,125.49s2.89-4.07,4.74-3-.35,7-2.53,7.74a2.21,2.21,0,0,1-3-1.21Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.59,124.13a0,0,0,0,1,0,.06,5.61,5.61,0,0,0-2.92,3.48,1.23,1.23,0,0,1,1.83-.32s0,.09,0,.08a1.35,1.35,0,0,0-1.5.47,6.18,6.18,0,0,0-.73,1.21c-.07.13-.32.06-.27-.1l0,0C585,127,586.49,124.31,588.59,124.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.77,107.38A18.37,18.37,0,0,1,581,106.2c2-.12,8.17.77,9.58,2.12s1.41,7.22,1.4,8.08-.74,6-2.7,7.14-1.56-7.68-4.33-10.8S575.77,107.38,575.77,107.38Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.77,107.38s6.38,2.25,9.14,5.37,2.37,11.91,4.33,10.79A4.15,4.15,0,0,0,591,120.9a21.48,21.48,0,0,0-3-9.56c-1.84-2.72-5.2-4.25-8.87-4.91A21.75,21.75,0,0,0,575.77,107.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.38,128.72c0-2.35-2-8.78-4.24-12.54s-9.48-6.35-10.51-6.36c-2.5,0-3.13,1.14-3.51.89s2.3-2.92,3-3.29a8,8,0,0,1,3.51-.64c1.08.1,7.73,1.2,10,4.21s5.15,11.23,4.39,13.24c-.19.48-.86.75-1.11,1.43-.34.9-.6,1.94-.92,2.57S588.38,128.93,588.38,128.72Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.67,114.53a11.68,11.68,0,0,0,1.7-1.09,8.11,8.11,0,0,0,1.48-1.39s.1,0,.07,0a6.9,6.9,0,0,1-1.37,1.58,5.86,5.86,0,0,1-1.83,1C583.64,114.67,583.6,114.56,583.67,114.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.56,126.39c.08-.17.2-.31.29-.47a4,4,0,0,0,.26-.56,4.83,4.83,0,0,1,.34-1.12,4.29,4.29,0,0,1,.6-.75,1.53,1.53,0,0,0,.52-.92s.08,0,.08,0c0,.72-.56,1.19-.91,1.76a8.44,8.44,0,0,0-.4,1.2,1.8,1.8,0,0,1-.68.94S588.53,126.44,588.56,126.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.92,123.8c.24-.25.49-.48.71-.75a7.79,7.79,0,0,0,.56-.85c.17-.28.31-.58.47-.88s.43-.66.6-1c0,0,.09,0,.07,0-.18.36-.3.76-.47,1.13a7,7,0,0,1-.51.93,4.83,4.83,0,0,1-.61.8,2.4,2.4,0,0,1-.8.62S587.9,123.82,587.92,123.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.22,121.45a6.74,6.74,0,0,0,1.37-1.35c.37-.51.72-1,1.06-1.57,0,0,.09,0,.07,0a7.6,7.6,0,0,1-.93,1.73,4.26,4.26,0,0,1-.64.7,4.45,4.45,0,0,1-.89.53A0,0,0,0,1,587.22,121.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.43,119.2a2.23,2.23,0,0,0,.67-.59c.22-.25.43-.5.64-.76l.6-.75a2.15,2.15,0,0,0,.47-.83s.09,0,.08,0a2.45,2.45,0,0,1-.33.9,5.64,5.64,0,0,1-.59.88,7.36,7.36,0,0,1-.71.77,1.57,1.57,0,0,1-.79.47A.05.05,0,0,1,586.43,119.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586,116.37c.23-.2.46-.4.67-.61s.42-.45.62-.67.43-.48.62-.73a0,0,0,0,1,.07,0,6.83,6.83,0,0,1-.49.82,6,6,0,0,1-.62.72,5.93,5.93,0,0,1-.69.63,2.33,2.33,0,0,1-.79.49.06.06,0,0,1-.06-.09A4.78,4.78,0,0,1,586,116.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582,113.08a9.57,9.57,0,0,1,.77-.79c.28-.25.58-.49.88-.71a10,10,0,0,1,1.9-1.1s.08,0,0,.06c-1.18.88-2.38,1.71-3.55,2.59A0,0,0,0,1,582,113.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.68,111a4.39,4.39,0,0,1,.84-.71,10.68,10.68,0,0,1,2.08-1,0,0,0,0,1,0,.07c-.64.36-1.28.72-1.89,1.11-.3.2-.6.41-.88.64s-.5.51-.77.75a0,0,0,0,1-.05,0A2.62,2.62,0,0,1,580.68,111Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.78,109.93a4.83,4.83,0,0,1,.79-.71,6,6,0,0,1,1.78-.89s.06,0,0,.07a12.35,12.35,0,0,0-1.69,1.07c-.27.2-.52.42-.78.63a9.45,9.45,0,0,1-.76.66s0,0,0,0A5.68,5.68,0,0,1,578.78,109.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.45,108.67c.26-.19.53-.36.8-.52a3.11,3.11,0,0,1,.84-.41,0,0,0,0,1,0,.07q-.75.52-1.5,1.08a7.94,7.94,0,0,0-1.18,1.21s-.05,0,0,0A2.9,2.9,0,0,1,577.45,108.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.72,108.17a4.93,4.93,0,0,1,1.63-.87s.06.06,0,.07a5.91,5.91,0,0,0-1.49,1,8,8,0,0,0-1.21,1.32s-.07,0,0,0A4,4,0,0,1,575.72,108.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.34,109.07a4,4,0,0,1,.23-.34,4.6,4.6,0,0,1,.56-.61,8.73,8.73,0,0,1,1.4-.93s.08,0,0,.07a6.6,6.6,0,0,0-1.32,1,6.1,6.1,0,0,0-.54.59,3.71,3.71,0,0,0-.23.32,2.27,2.27,0,0,1-.22.32,0,0,0,0,1-.06,0A1.17,1.17,0,0,1,573.34,109.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.93,109.1a4.24,4.24,0,0,1,.46-.49,5.27,5.27,0,0,1,.52-.44l.56-.41s.09,0,0,.06a3.23,3.23,0,0,0-.52.46l-.48.46-.47.46a5.32,5.32,0,0,1-.47.48,0,0,0,0,1-.05,0A3.49,3.49,0,0,1,571.93,109.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M536.1,446.54c.12,2-5.48,2.41-7.78,1.1a52.74,52.74,0,0,1-5.29-4.51c-5.51-5.05-13.11-12.44-13.11-12.44l-5.78,2.47-23.59,8.6-15.83-30.58s13.66-5.48,26.64-10.37c2-.75,4-1.48,5.87-2.18l.36-.13c8.71-3.17,15.92-5.55,16.64-5C516.18,394.89,536,444.57,536.1,446.54Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.1,446.54c.12,2-5.48,2.41-7.78,1.1a52.74,52.74,0,0,1-5.29-4.51c5.82-.67-21.71-39.43-25.44-44.63,8.71-3.17,15.92-5.55,16.64-5C516.18,394.89,536,444.57,536.1,446.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.94,438.72s-61.14,12.84-83.46,8.39C404.8,445,397.32,431,402.67,420.57c5-9.76,34.56-19.22,43-24.86,2.65-1.77,2.51-9,2.51-9l21.81.11s7.54,12.5,4.14,18.45a2.4,2.4,0,0,1-.19.29l9.9-3.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.77,422c-2.33-5.32-4.9-10.52-7.27-15.82,0-.1-.21-.05-.16.06,2.23,5.33,4.28,10.74,6.61,16s4.86,10.53,7.31,15.79c.06.14.28.07.22-.07C490.23,432.67,488.09,427.3,485.77,422Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.05,405.84c-1.52.84-3,1.84-4.45,2.75s-2.93,1.8-4.42,2.65q-4.51,2.56-9.2,4.82A155.22,155.22,0,0,1,436.61,424c-3.69,1.22-7.42,2.41-11.22,3.28-.08,0-.05.15,0,.13,2.76-.61,5.52-1.21,8.25-1.92-1.45.88-2.89,1.8-4.34,2.69a.07.07,0,0,0,.07.12c1.58-.92,3.19-1.8,4.76-2.74a.15.15,0,0,0,.05-.22c.47-.12.94-.24,1.4-.38,3.39-1,6.73-2.08,10-3.34a122.65,122.65,0,0,0,18.79-9.07q2.54-1.5,5-3.1A47.13,47.13,0,0,0,474.2,406C474.31,405.94,474.17,405.77,474.05,405.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.33,454.45c.11,2-5.48,2.42-7.79,1.11a53.38,53.38,0,0,1-5.29-4.52c-5.5-5.05-13.11-12.44-13.11-12.44l-5.78,2.47-23.59,8.6L487.94,419.1s13.66-5.48,26.64-10.38l5.88-2.18.35-.13c8.71-3.16,15.92-5.55,16.65-5C539.41,402.81,559.22,452.48,559.33,454.45Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.33,454.45c.11,2-5.48,2.42-7.79,1.11a53.38,53.38,0,0,1-5.29-4.52c5.83-.67-21.7-39.43-25.44-44.63,8.71-3.16,15.92-5.55,16.65-5C539.41,402.81,559.22,452.48,559.33,454.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.65,386.73l37.51.13s7.58,20.39,4.17,26.35-38.11,13.91-38.11,13.91L507,410l15.12,36.68s-58,11.5-88.52,7.81c-11.47-1.39-18.4-16.53-11.46-27.94,7.31-12,33.32-28.12,33.32-28.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.81,409.83c-14.66,6.37-29.44,12.44-44.54,17.7q-3.13,1.1-6.3,2.16c-2.18.74-4.35,1.59-6.57,2.18a.08.08,0,1,0,.05.16c1.92-.68,3.92-1.15,5.87-1.75s3.81-1.18,5.71-1.8l2.45-.82L462,428c-.76.49-1.52,1-2.26,1.48-1.54,1-3,2.28-4.59,3.2a.09.09,0,0,0,.1.15c1.53-1.05,3.25-1.82,4.82-2.8.77-.48,1.51-1,2.26-1.49a15.61,15.61,0,0,0,2-1.47q3.61-1.21,7.19-2.5,11.29-4.05,22.3-8.79c4.1-1.76,8.17-3.6,12.19-5.55C506.19,410.1,506,409.73,505.81,409.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.84,429.61c-2.33-5.31-4.9-10.52-7.27-15.81,0-.11-.21-.05-.16.05,2.23,5.34,4.28,10.74,6.61,16s4.86,10.53,7.31,15.8c.06.13.28.06.22-.08C514.3,440.28,512.16,434.91,509.84,429.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.81,398.76a102.15,102.15,0,0,0-12,7.64c-3.81,2.72-7.51,5.6-11,8.67-1.78,1.55-3.51,3.18-5.17,4.85a37.09,37.09,0,0,0-4.41,5.13,18.28,18.28,0,0,0-3.32,11.38,19.37,19.37,0,0,0,1.37,6.28,22.92,22.92,0,0,0,3.37,5.43c.05.07.15,0,.09-.09a14.85,14.85,0,0,1-2.83-5.19,19.34,19.34,0,0,1,1.77-16.48c2.37-3.78,5.82-6.88,9.09-9.86a135.41,135.41,0,0,1,10.59-8.69c2.07-1.53,4.16-3,6.28-4.46s4.27-2.85,6.34-4.38A.13.13,0,0,0,454.81,398.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.68,400.47a43.67,43.67,0,0,0-9.54-2c-3.19-.42-6.39-.65-9.6-.75a.07.07,0,1,0,0,.13c3.25.35,6.49.82,9.72,1.36s6.23,1.27,9.38,1.58C465.83,400.8,465.84,400.53,465.68,400.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.46,402.65a45.83,45.83,0,0,1-6-.65,9.73,9.73,0,0,1-4.65-1.59c-2.63-2-3.64-5.57-4.15-8.71,0-.07-.14-.06-.13,0,.39,3.41.47,7.33,3.42,9.67a9.06,9.06,0,0,0,5.07,1.69,31.86,31.86,0,0,0,6.4-.28A.08.08,0,1,0,488.46,402.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.2,406.87a40.3,40.3,0,0,0-.94-5.87c-.44-2-1-3.95-1.55-5.9-.67-2.2-1.46-4.38-2.28-6.53,0-.08-.16-.05-.13,0,1.17,3.65,2.23,7.33,3.1,11.06.44,1.85.82,3.7,1.15,5.57a11.54,11.54,0,0,1-.06,5.45,9.6,9.6,0,0,1-3.09,4.61s0,0,0,0A9.82,9.82,0,0,0,495.2,406.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.41,418.11c-2.55.62-5,1.44-7.54,2.2s-5,1.52-7.51,2.3c-5,1.57-10,3.19-15,4.81-2.83.92-5.64,1.9-8.45,2.87a.07.07,0,0,0,0,.13q15.09-4.38,30-9.33c2.82-.94,5.69-1.79,8.45-2.89A0,0,0,1,0,501.41,418.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.22,341.89c-.71-2.05-1.36-4.13-1.9-6.23a60.27,60.27,0,0,1-2.38-9.05c-.89-5.07-1.63-11.25,2.4-15.2a18.54,18.54,0,0,1,6.7-3.85c2.52-.91,5.29-1.59,7.95-.85a6.93,6.93,0,0,1,2.83,1.54,17.24,17.24,0,0,1,5.46,1.3c2.08.52,3.75,2.33,5,4a28.35,28.35,0,0,1,3.25,6.66,17.2,17.2,0,0,1,1.35,6.66,35,35,0,0,1-1,6,21.08,21.08,0,0,0-.58,7.29c0,.08-.11.11-.13,0-.67-3.91.77-7.76,1.2-11.61a15.55,15.55,0,0,0-.63-6.5,38.2,38.2,0,0,0-2.91-7,12.47,12.47,0,0,0-4.52-5l.11.07c2.27,1.52,3.61,4,4.67,6.48a30.92,30.92,0,0,1,2.49,8.56,29.31,29.31,0,0,1-.47,8.09,30.63,30.63,0,0,0-.65,8.1,23.58,23.58,0,0,0,2.8,8,34.09,34.09,0,0,1,3.17,7.62,12,12,0,0,1-.62,7.31c-1.81,4.28-6.82,8.33-11.63,6.3a15.51,15.51,0,0,1-3.3-2.07,39.17,39.17,0,0,1-3.17-2.72,48.14,48.14,0,0,1-5.75-6.75,87.8,87.8,0,0,1-8.42-15.44c-.59-1.32-1.15-2.65-1.69-4a87.28,87.28,0,0,0,3.55,9.12,59.72,59.72,0,0,0,9.3,15.08,38.22,38.22,0,0,0,3.26,3.23c1.25,1.1,2.59,2.05,3.92,3.07a.08.08,0,0,1-.09.13,30,30,0,0,1-6.54-5.34,41.13,41.13,0,0,1-5.33-6.92A79.54,79.54,0,0,1,444.22,341.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.17,353.23c-7,17-18.46,34.07-22.41,35.67-5.42,2.19-31.29-11.55-37.89-14.36C396.2,373.4,409.36,353.35,412,355c6.48,4.17,20.11,10.55,20.43,10.76.65.43,15.63-13.78,19.85-18.21C461.62,337.72,462.65,344.78,459.17,353.23Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.83,359.15a64.5,64.5,0,0,0-6.16-7.15c-2.23-1.92-13.17-6-14.19-3.69-1.31,3,4.54,6.59,7.64,8,0,0-3,6.9.6,10.4S416.83,359.15,416.83,359.15Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.92,375.45c-2.32-.94-12.59-6.21-15.11-8.32s-9.37-8.69-7.95-10.79,3.57-.33,3.57-.33-2.44-3.24-.83-5.22,4.88.88,4.88.88-2.26-3.51-.51-5.38,4.55,1.57,4.55,1.57-2.22-3.11-.13-4c2.52-1.12,6,5.08,8.94,7.2.67.48,14.34,8.76,14.34,8.76Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.28,347.57c2.55,4.55,4.45,6.1,9,8.55.08.05,0,.19-.06.15-4.64-2-7.31-3.6-9.14-8.59C389,347.44,389.16,347.35,389.28,347.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.29,351.3c3.06,4.5,5.11,6.2,9.65,9.11.06,0,0,.16-.07.12-4.69-2.49-7.32-4.14-9.78-9C385,351.27,385.15,351.09,385.29,351.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.67,356.15c3.28,4.14,5.44,6.1,10.21,8.36a.1.1,0,1,1-.07.18,17.51,17.51,0,0,1-10.26-8.43C381.39,356,381.46,355.89,381.67,356.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.39,349.25c.77,3.58,4.95,5.15,7.86,6.72a.3.3,0,0,1,.07.49c-1.08,3-1.74,7.5.19,10.23a.08.08,0,0,1-.12.1c-2.46-2.65-2.18-7.14-.78-10.33-3-1.57-7.13-3.32-7.25-7.21C396.36,349.23,396.39,349.22,396.39,349.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.24,373.1l-11.56-17.2a131.12,131.12,0,0,1,11.46-11.09c6.83-5.89,10.92-3.86,8.11,8A77.1,77.1,0,0,1,452.24,373.1Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.24,373.1l-11.56-17.2a131.12,131.12,0,0,1,11.46-11.09c6.83-5.89,10.92-3.86,8.11,8A77.1,77.1,0,0,1,452.24,373.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.2,354.2c1,1.18,1.83,2.52,2.73,3.77s1.72,2.4,2.53,3.63c1.7,2.55,3.35,5.12,4.94,7.74,0,0,0,.09-.08.05q-2.65-3.69-5.21-7.43c-.85-1.25-1.66-2.51-2.47-3.78s-1.78-2.56-2.52-3.92A.05.05,0,0,1,443.2,354.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.75,394.92c-1.49,1-51.73.41-51.73.41l2-18.95s-4.15-4.44-4.27-9.79c-.17-7.14,8.14-20.25,8.93-21.16,3.18-3.67,6.52-5,10.22-4.17C477.35,344.68,496.75,394.92,496.75,394.92Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.33,372.81a31.23,31.23,0,0,0-5.63,1.07c-.91.27-1.82.6-2.72,1-.45.18-.9.33-1.35.49a5,5,0,0,1-1.45.32,0,0,0,0,0,0,.08,7.17,7.17,0,0,0,1.39,0,7.92,7.92,0,0,0,1.33-.29c.93-.27,1.86-.6,2.79-.88,1.88-.57,3.75-1.14,5.66-1.54C459.44,373,459.42,372.8,459.33,372.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,375a33.25,33.25,0,0,0-4.67-.35,22.78,22.78,0,0,0-2.34.13l-1.12.14c-.41.06-.81.19-1.22.24,0,0-.05.09,0,.08.39,0,.78,0,1.16,0l1.17,0,2.34,0c1.56,0,3.12-.06,4.68,0C464,375.15,464,375,464,375Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.14,342.67c-.11.89-3.66,7-7.64,7.19-1.3.07-2-7-2-7l-.17-.5-2.4-7.14,9.17-7.27S462.19,342.29,462.14,342.67Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.91,335.22l2.4,7.13a15.13,15.13,0,0,0,7.82-9.5c-.53-2.49-1-4.56-1-4.86v0l-1.17.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.65,326.07c.3,13.22,8.25,14.53,11.1,14.46,2.58-.06,11.38-.6,12.45-13.78s-5.18-17.21-11.1-17.38S437.34,312.86,437.65,326.07Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.15,324.39A6.24,6.24,0,0,0,440,324a1.49,1.49,0,0,0,.79-.53.47.47,0,0,0-.12-.56,1.16,1.16,0,0,0-1.18,0,1.7,1.7,0,0,0-.93.8A.5.5,0,0,0,439.15,324.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.37,324.12a7,7,0,0,1-.91-.07,1.54,1.54,0,0,1-.91-.26.47.47,0,0,1-.07-.57,1.17,1.17,0,0,1,1.11-.41,1.69,1.69,0,0,1,1.14.47A.5.5,0,0,1,448.37,324.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.38,326.22s.07,0,.07.08c0,.9.23,1.92,1.06,2.16,0,0,0,.06,0,.05C446.51,328.44,446.27,327.08,446.38,326.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.12,325.23c1.43-.21,1.75,2.68.42,2.87S445.91,325.41,447.12,325.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.7,325.32c.27.14.55.4.86.4s.58-.34.78-.66c0,0,.05,0,.06,0,.06.56-.09,1.15-.67,1.29s-1-.31-1.17-.85C447.52,325.43,447.59,325.27,447.7,325.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.44,326.54s-.06,0-.05.09c.13.89.13,1.93-.64,2.32,0,0,0,.06,0,.05C441.73,328.75,441.71,327.36,441.44,326.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.54,325.7c-1.45.06-1.23,3,.11,2.9S441.75,325.65,440.54,325.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,325.94c-.22.17-.42.47-.7.51s-.57-.25-.8-.54c0,0,0,0,0,0,0,.55.26,1.11.8,1.18s.81-.44.9-1C440.13,326,440,325.87,440,325.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.44,334.06c-.18.24-.35.56-.67.64a2.37,2.37,0,0,1-1-.08s-.06,0,0,.05a1.19,1.19,0,0,0,1.2.31,1,1,0,0,0,.58-.89A0,0,0,0,0,447.44,334.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.25,331.11s-.05,1.35,0,2c0,.06.16.07.38.07h0a3,3,0,0,0,2.81-1.4c0-.06-.05-.12-.11-.08a4.45,4.45,0,0,1-2.66,1.05c-.06-.17.17-2.31.07-2.31a5.32,5.32,0,0,0-1.4.46c0-2.83.52-5.63.51-8.44,0-.1-.15-.12-.17,0a45.62,45.62,0,0,0-.93,9.07C441.76,331.84,443,331.24,443.25,331.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,332.9a3.4,3.4,0,0,0,1.43,1,1.55,1.55,0,0,0,.93,0c.66-.23.63-.85.47-1.36a3.58,3.58,0,0,0-.36-.79A4.43,4.43,0,0,1,444,332.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.41,333.85a1.55,1.55,0,0,0,.93,0c.66-.23.63-.85.47-1.36A1.57,1.57,0,0,0,445.41,333.85Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.63,326.37c-1.43.05-5.49-3.53-6.23-10.39,0,0,1.09,6.11,1.64,7s-2.28-2-3-7.54a22.47,22.47,0,0,1-5.42,3.47c-2.55,1-4.16,1.1-4.36.93s3.54-1.74,4.47-3c0,0-6.67,3.87-9.86,4.41-.37.07-.67-6.88,4-10.57s12-1.57,14.31.28c0,0,2.51.13,5.54,3.55S462.18,326.32,460.63,326.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.12,327.82s2.42-4.42,4.39-3.6.47,7-1.63,8a2.22,2.22,0,0,1-3.1-.87Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,326s.05,0,0,.06a5.65,5.65,0,0,0-2.51,3.83,1.22,1.22,0,0,1,1.79-.54c.05,0,0,.09,0,.09a1.37,1.37,0,0,0-1.45.64,6.64,6.64,0,0,0-.59,1.3c-.05.14-.31.1-.27-.07v0C459.74,329.31,461,326.41,463,326Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.77,369s-18.83,9.77-41.67,9.77A93.16,93.16,0,0,1,350.79,369V352.78l83,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.54,356.17c-7.25,16.92-16.49,31-20.47,32.53-5.45,2.11-25.41,1.6-32.09.74-2.87-.37-.14-22.66,2.94-22.28,7.85,1,22.34,1,22.65,1.18.65.44,15.83-13.55,20.12-17.92C469.21,340.7,470.14,347.77,466.54,356.17Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,361.29c-2,2-4,4-6.13,5.8a17.38,17.38,0,0,1-1.69,1.33,1.39,1.39,0,0,1-.65.25l-.54,0-1.06,0-4.21-.18c-2.8-.17-5.61-.32-8.41-.53s-5.6-.44-8.4-.74c2.81,0,5.62.07,8.43.16s5.61.25,8.42.36l4.2.25,1,.06.52,0s.18-.07.31-.14c.55-.36,1.11-.8,1.67-1.22C443.71,364.91,445.84,363.08,448,361.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.34,367.32c1.49-.35,1.31-1.13-1.15-2.27s-13.17-3.54-12-7.21,16.21,0,20.16,2.16a71.36,71.36,0,0,1,9.58,7.16C413.85,367,406.37,367.47,400.34,367.32Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,389.44c-8.84-.44-19.82-.81-27.85-6.38a4.83,4.83,0,0,1-1.94-2.51c-3.64-2.44-3.59-4.89-3.59-4.89-2.7-3.3-2.3-5.8-2.3-5.8s-4.25-2.9-2.92-5.76c1.48-3.21,7.16,1.49,11.86,2.17,10.78,1.55,26.53.75,29.68.89Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.39,375.83a69.58,69.58,0,0,1-9.36-1.89,69.66,69.66,0,0,1-9.61-4.12.09.09,0,0,0-.09.15,37,37,0,0,0,19,6C397.52,376,397.55,375.86,397.39,375.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.4,382.48c-3-.68-8.4-1.91-16.75-6.91,0,0-.06,0,0,.05a33.17,33.17,0,0,0,16.74,7C397.56,382.65,397.6,382.52,397.4,382.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.33,386c-5.14-1.34-8.21-2.85-13.11-5.5,0,0-.06,0,0,0,5.25,3.6,7.57,4.31,13.12,5.64C397.5,386.27,397.53,386.1,397.33,386Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.32,375.94,448,358.57a132.83,132.83,0,0,1,11.61-10.92c6.91-5.79,11-3.71,8,8.08A77.25,77.25,0,0,1,459.32,375.94Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.55,356.91c1,1.2,1.79,2.54,2.67,3.81s1.69,2.43,2.49,3.66q2.49,3.86,4.82,7.81c0,.05,0,.1-.08.05q-2.59-3.72-5.1-7.5c-.83-1.26-1.63-2.54-2.42-3.81s-1.74-2.59-2.46-4A.05.05,0,0,1,450.55,356.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.72,373.47c.07.06,1.56,2.29,1.58,2.32,1.23-2.54,2.52-4.93,3.7-7.5a83.14,83.14,0,0,0,3.14-8.07q.8-2.34,1.45-4.72s.06,0,.05,0c-.28,1.39-.61,2.78-1,4.15.29-.66.54-1.33.77-2a.05.05,0,1,1,.1,0,11,11,0,0,1-1.12,2.86A62.42,62.42,0,0,1,461.81,372a34,34,0,0,1-2.53,4.33s-1.61-2.71-1.63-2.8S457.69,373.44,457.72,373.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.28,356.85c.52-.55,1.05-1.08,1.6-1.61l.33-.33a26.76,26.76,0,0,1,1.68-2.28s.06,0,0,0a20.39,20.39,0,0,1-1.23,1.8,33.25,33.25,0,0,1,2.6-2.29s.06,0,0,0c-1,1.12-2.11,2.18-3.16,3.26-.51.53-3.09,3.06-3.07,3.09s1,1.7,1,1.81,0,.07,0,0-1.34-1.94-1.34-1.94Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.05,138A25.21,25.21,0,1,0,263.26,113,25.08,25.08,0,0,0,238.05,138Zm13.44,0a11.78,11.78,0,1,1,11.77,11.65A11.71,11.71,0,0,1,251.49,138Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.42 114.07 268.11 114.07 267.57 107.27 258.95 107.27 258.42 114.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.87 117.3 283.73 124.08 288.2 118.91 282.1 112.87 276.87 117.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.61 132.5 287.61 142.09 294.47 141.56 294.47 133.03 287.61 132.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.34 150.76 277.49 157.55 282.72 161.97 288.82 155.94 284.34 150.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.98 161.39 259.29 161.39 259.82 168.18 268.45 168.18 268.98 161.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.53 158.16 243.67 151.37 239.2 156.55 245.3 162.59 250.53 158.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.79 142.96 239.79 133.36 232.93 133.89 232.93 142.43 239.79 142.96",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.06 124.69 249.91 117.91 244.68 113.48 238.58 119.52 243.06 124.69",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,132.35l-7.77-2.06-5.69,5.64,2.08,7.68,7.77,2.07,5.7-5.63Zm-5.69,8.16a2.53,2.53,0,1,1,2.55-2.53A2.54,2.54,0,0,1,263.26,140.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.88,102.77a7,7,0,1,0-6.4-7.64A7.08,7.08,0,0,0,301.88,102.77Zm-5.54-7.56a6.22,6.22,0,1,1,5.62,6.71A6.2,6.2,0,0,1,296.34,95.21Zm5.54,7.56a7,7,0,1,0-6.4-7.64A7.08,7.08,0,0,0,301.88,102.77Zm-5.54-7.56a6.22,6.22,0,1,1,5.62,6.71A6.2,6.2,0,0,1,296.34,95.21Zm5.54,7.56a7,7,0,1,0-6.4-7.64A7.08,7.08,0,0,0,301.88,102.77Zm-5.54-7.56a6.22,6.22,0,1,1,5.62,6.71A6.2,6.2,0,0,1,296.34,95.21Zm4.81,15.3a14.79,14.79,0,1,0-13.49-16.09A14.92,14.92,0,0,0,301.15,110.51ZM294.38,95a8.19,8.19,0,1,1,7.4,8.82A8.18,8.18,0,0,1,294.38,95Zm1.1.1a7.09,7.09,0,1,0,7.71-6.33A7,7,0,0,0,295.48,95.13Zm.86.08a6.22,6.22,0,1,1,5.62,6.71A6.2,6.2,0,0,1,296.34,95.21Zm5.54,7.56a7,7,0,1,0-6.4-7.64A7.08,7.08,0,0,0,301.88,102.77Zm-5.54-7.56a6.22,6.22,0,1,1,5.62,6.71A6.2,6.2,0,0,1,296.34,95.21Zm5.54,7.56a7,7,0,1,0-6.4-7.64A7.08,7.08,0,0,0,301.88,102.77Zm-5.54-7.56a6.22,6.22,0,1,1,5.62,6.71A6.2,6.2,0,0,1,296.34,95.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301 81.41 306.72 81.93 306.78 77.9 301.7 77.43 301 81.41",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.71 84.32 315.38 88.69 318.31 85.88 315.04 81.99 311.71 84.32",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.21 93.87 316.68 99.53 320.75 99.59 321.23 94.55 317.21 93.87",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.27 104.47 309.85 108.1 312.69 110.99 316.62 107.76 314.27 104.47",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.62 109.9 298.9 109.38 298.84 113.41 303.93 113.88 304.62 109.9",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.91 106.99 290.24 102.62 287.31 105.43 290.58 109.32 293.91 106.99",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.42 97.44 288.95 91.78 284.87 91.72 284.39 96.76 288.42 97.44",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.35 86.85 295.77 83.22 292.93 80.32 289 83.55 291.35 86.85",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.15,102.53a8.54,8.54,0,1,0-7.79-9.3A8.6,8.6,0,0,0,233.15,102.53Zm-6.74-9.2a7.57,7.57,0,1,1,6.83,8.16A7.55,7.55,0,0,1,226.41,93.33Zm6.74,9.2a8.54,8.54,0,1,0-7.79-9.3A8.6,8.6,0,0,0,233.15,102.53Zm-6.74-9.2a7.57,7.57,0,1,1,6.83,8.16A7.55,7.55,0,0,1,226.41,93.33Zm6.74,9.2a8.54,8.54,0,1,0-7.79-9.3A8.6,8.6,0,0,0,233.15,102.53Zm-6.74-9.2a7.57,7.57,0,1,1,6.83,8.16A7.55,7.55,0,0,1,226.41,93.33ZM232.26,112a18,18,0,1,0-16.42-19.59A18.15,18.15,0,0,0,232.26,112ZM224,93.11a10,10,0,1,1,9,10.74A10,10,0,0,1,224,93.11Zm1.34.12a8.63,8.63,0,1,0,9.39-7.71A8.57,8.57,0,0,0,225.36,93.23Zm1,.1a7.57,7.57,0,1,1,6.83,8.16A7.55,7.55,0,0,1,226.41,93.33Zm6.74,9.2a8.54,8.54,0,1,0-7.79-9.3A8.6,8.6,0,0,0,233.15,102.53Zm-6.74-9.2a7.57,7.57,0,1,1,6.83,8.16A7.55,7.55,0,0,1,226.41,93.33Zm6.74,9.2a8.54,8.54,0,1,0-7.79-9.3A8.6,8.6,0,0,0,233.15,102.53Zm-6.74-9.2a7.57,7.57,0,1,1,6.83,8.16A7.55,7.55,0,0,1,226.41,93.33Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.08 76.52 239.05 77.16 239.12 72.25 232.93 71.68 232.08 76.52",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.12 80.06 249.59 85.39 253.15 81.97 249.18 77.23 245.12 80.06",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.81 91.69 251.16 98.58 256.13 98.66 256.7 92.53 251.81 91.69",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.23 104.59 242.85 109.02 246.31 112.54 251.1 108.61 248.23 104.59",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.48 111.21 229.52 110.57 229.44 115.49 235.64 116.06 236.48 111.21",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.44 107.67 218.97 102.35 215.41 105.77 219.38 110.51 223.44 107.67",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.75 96.04 217.4 89.15 212.43 89.08 211.86 95.21 216.75 96.04",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.33 83.14 225.71 78.72 222.25 75.19 217.47 79.13 220.33 83.14",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.48 406.92 271.03 406.92 227.25 203.07 181.14 203.07 207.49 406.92 202.11 406.92 175.15 198.35 231.69 198.35 276.48 406.92",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.48 406.92 271.03 406.92 227.25 203.07 181.14 203.07 207.49 406.92 202.11 406.92 175.15 198.35 231.69 198.35 276.48 406.92",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.6,
    y: 193.46,
    width: 62.69,
    height: 5.63,
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.6,
    y: 193.46,
    width: 62.69,
    height: 5.63,
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.66 199.09 209.6 417.86 204.23 417.86 225.75 204.45 179.61 204.45 140.7 417.86 135.25 417.86 175.15 199.09 231.66 199.09",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.42,
    y: 246.13,
    width: 54.51,
    height: 5.35,
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.77,
    y: 289.5,
    width: 54.51,
    height: 5.35,
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.55,
    y: 332.88,
    width: 59.49,
    height: 5.35,
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.45,
    y: 376.26,
    width: 63.3,
    height: 5.35,
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "231.66 199.09 209.6 417.86 204.23 417.86 225.75 204.45 179.61 204.45 140.7 417.86 135.25 417.86 175.15 199.09 231.66 199.09"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 171.42,
    y: 246.13,
    width: 54.51,
    height: 5.35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 162.77,
    y: 289.5,
    width: 54.51,
    height: 5.35
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 153.55,
    y: 332.88,
    width: 59.49,
    height: 5.35
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 146.45,
    y: 376.26,
    width: 63.3,
    height: 5.35
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M152.19,270l-18.84,35.48c-1.1,6.7-1.94,12.59-2.09,15.68a.11.11,0,0,0,0,.05,4.69,4.69,0,0,0,.16,2.15l0,.05c1.77,1.68,55.06,12,57,11.76s1.38-5.92-.37-8-20.38-15.14-20.38-15.14l18.49-35.49Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.86,298.44l-3.51,7.08c-1.1,6.7-1.94,12.59-2.09,15.68a.11.11,0,0,0,0,.05,9.17,9.17,0,0,0,.16,2.15l0,.05c1.77,1.68,55.06,12,57,11.76s1.38-5.92-.37-8-20.38-15.14-20.38-15.14l3.62-7.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,312.66c-3.46-1.18-7.9-1.27-11,.87-.12.09,0,.26.12.24a50.63,50.63,0,0,1,10.79-.66A.23.23,0,0,0,171,312.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.35,314.59c-3.47-1.19-7.9-1.27-11,.87-.12.08,0,.25.13.23a49.94,49.94,0,0,1,10.79-.65A.23.23,0,0,0,173.35,314.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.7,316.51c-3.47-1.18-7.91-1.27-11,.87-.12.09,0,.25.12.23a51.34,51.34,0,0,1,10.8-.65A.23.23,0,0,0,175.7,316.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.48,335.21c-2,.27-55.27-10.07-57-11.76-.69-.63.37-8.48,1.91-17.93l.06-.29,34.45,6.29-.13.58s18.62,13.08,20.38,15.14S190.46,335,188.48,335.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.4,305.22l-.05.31c-1.54,9.44-2.6,17.29-1.91,17.92s12.3,3.33,24.76,5.87c14.91,3,31.2,6,32.28,5.9,2-.26,1.37-5.94-.37-8s-20.38-15.13-20.38-15.13l.13-.58-11.49-2.1Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.28,333c-8.94-2-45.18-9-54.17-10.31-.07,0-.08,0,0,.06,8.82,2.14,45.12,8.93,54.15,10.4C188.44,333.21,188.47,333.07,188.28,333Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.37,309.42c-.12,5.93-.27,14.66-.17,19.9,14.91,3,31.2,6,32.28,5.9,2-.26,1.37-5.94-.37-8s-20.38-15.13-20.38-15.13l.13-.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.22,293.44,177.69,298s41.89-64.38,37.68-86.63c-2.32-12.24-44-31.47-44-31.47l-4.21-8.46H137.85s-12,17.64-3.38,34.22c5.84,11.26,37.93,19.85,39.11,23.47C175.14,233.9,138.22,293.44,138.22,293.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.34,288.27a29.78,29.78,0,0,1,3.13.13c1.17.06,2.32.11,3.48.2,2.23.17,4.46.4,6.68.66,4.48.52,9,1.09,13.41,1.77,2.53.39,5.07.8,7.59,1.25a.08.08,0,0,1,0,.16c-4.46-.38-8.91-.84-13.36-1.29s-8.9-.9-13.32-1.51c-1.27-.18-2.54-.35-3.8-.57s-2.57-.31-3.79-.65C143.26,288.4,143.25,288.28,143.34,288.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.3,287.67c3.49-5.33,22.26-39.24,25.06-45,1.41-2.85,2.76-5.73,4-8.66a77.3,77.3,0,0,0,3.24-8.92c.84-3,1.61-6.18,1-9.18a12.8,12.8,0,0,0-1.78-4.23,22.77,22.77,0,0,0-1.34-1.92c-.51-.59-1-1.2-1.55-1.76-4.41-4.52-9.9-7.86-15.42-11s-11.36-5.74-17.13-8.43c-1.44-.69-2.88-1.37-4.3-2.1-.71-.37-1.42-.75-2.11-1.16a4.82,4.82,0,0,1-1.8-1.62,22.65,22.65,0,0,1-2.56-9.16,22.48,22.48,0,0,0,2.77,9,4.37,4.37,0,0,0,1.75,1.48c.68.4,1.39.75,2.1,1.1,1.44.69,2.89,1.34,4.34,2,5.82,2.6,11.65,5.19,17.29,8.2a91.4,91.4,0,0,1,8.24,4.92,48.29,48.29,0,0,1,7.46,6.09c.57.58,1.09,1.2,1.61,1.82a19.85,19.85,0,0,1,1.41,2,13.79,13.79,0,0,1,1.92,4.51,13.58,13.58,0,0,1,.1,4.92c-.15.79-.25,1.6-.44,2.39s-.37,1.57-.6,2.34a77.15,77.15,0,0,1-3.33,9c-1.25,3-2.62,5.83-4,8.69C197.29,248.82,177.92,282.43,174.3,287.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.82,322.6s.3,35.51.3,35.53c0,6.79.16,12.74.52,15.82a.11.11,0,0,0,0,.05,4.71,4.71,0,0,0,.51,2.09s0,0,0,0c2,1.37,56.29,2.78,58.2,2.19s.38-6.08-1.68-7.81-22.61-11.57-22.61-11.57l-.63-35.48Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.06,350.84s.06,7.27.06,7.29c0,6.79.16,12.74.52,15.82a.11.11,0,0,0,0,.05,8.8,8.8,0,0,0,.51,2.09s0,0,0,0c2,1.37,56.29,2.78,58.2,2.19s.38-6.08-1.68-7.81-22.61-11.57-22.61-11.57l0-7.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.44,359c-3.62-.59-8,.05-10.7,2.68-.11.1,0,.24.15.2a50.69,50.69,0,0,1,10.54-2.42A.23.23,0,0,0,211.44,359Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.07,360.47c-3.61-.59-8,0-10.7,2.68-.11.1,0,.24.16.21a49.94,49.94,0,0,1,10.54-2.43A.23.23,0,0,0,214.07,360.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.7,362c-3.61-.59-8,0-10.7,2.68-.1.1,0,.25.16.21a50.08,50.08,0,0,1,10.54-2.43A.23.23,0,0,0,216.7,362Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.4,378.32c-1.91.59-56.17-.82-58.2-2.19-.78-.5-1-8.42-1.07-18v-.3l35,.52,0,.59s20.52,9.83,22.6,11.57S234.31,377.74,232.4,378.32Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.84,376.2c-9.14-.46-46.05-1.46-55.12-1.23-.08,0-.08.06,0,.06,9,.66,46,1.36,55.13,1.32C232,376.35,232,376.21,231.84,376.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.88,209s16.11,50.77,16.4,60.11c.25,7.95-.77,78.15-.77,78.15l40.78.24s-3.44-71.81-4.08-80.1c-1.19-15.51-14.77-58.07-24.48-96h-44s.39,19.86,9.42,34.22C148.18,205.66,152.26,207.55,154.88,209Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.68,339.76c4.71-.14,9.6-.28,14.31-.16s9.36.19,14,.47c2.65.15,5.29.24,7.93.5a.08.08,0,0,1,0,.15c-4.71.27-9.43.22-14.15.17s-9.35-.09-14-.3c-2.64-.13-5.28-.26-7.93-.44C172.55,340.13,172.4,339.77,172.68,339.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.6,195.36c1.45,4.85,2.68,9.78,4,14.67s2.62,9.87,3.92,14.81c2.51,9.55,5,19.11,6.88,28.81a175.48,175.48,0,0,1,3.26,29.54c.22,10.11,0,20.23-.06,30.34s-.16,8.89-.33,19.05c0,1.26-.05,2.53-.1,3.79a.1.1,0,0,1-.19,0c-.27-10.11-.13-8.8-.09-18.91s.16-20.23.08-30.35a182.24,182.24,0,0,0-2.6-29.95c-1.7-9.73-4.1-19.32-6.58-28.88q-2.13-8.17-4.27-16.35c-1.42-5.49-2.94-11-4.2-16.5A.15.15,0,0,1,181.6,195.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,210a35.2,35.2,0,0,1-6.06-.55c-2-.38-3.9-1-5.86-1.62a46.74,46.74,0,0,0-5.76-1,20.24,20.24,0,0,1-5.64-1.67c-.08-.05-.15.08-.07.12a35.53,35.53,0,0,0,5.41,2.35c1.93.6,3.95.69,5.91,1.17a50.29,50.29,0,0,0,6,1.39,22.29,22.29,0,0,0,6.05-.1C165.07,210.12,165,210,165,210Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.42,306.63l-.07-12.5q0-6.25-.11-12.5c-.1-4.17-.13-8.34-.42-12.47a36.43,36.43,0,0,0-1-6.1c-.45-2-1-4-1.5-6.05-2.06-8.07-4.36-16.08-6.63-24.1l-6.83-24.06c1.32,4,2.58,7.93,3.85,11.9l3.69,11.95q3.63,12,6.85,24.07c.51,2,1,4,1.46,6.09a37.26,37.26,0,0,1,1,6.23c.25,4.19.3,8.36.28,12.53Q171.94,294.13,171.42,306.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,249.93c-1.52-5.27-2.95-10.56-4.38-15.85l-4.22-15.88-4.15-15.9c-.68-2.66-1.39-5.3-2.12-7.94s-1.4-5.3-2.38-7.86a140.64,140.64,0,0,1,5.22,15.6c1.54,5.26,2.94,10.56,4.37,15.85s2.72,10.62,4,16S202.82,244.57,204,249.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.73,125.5c0,.86,2.75,7.07,6.55,7.73,1.24.21,2.69-6.49,2.69-6.49l.23-.47,3.08-6.58-7-7-1-1s-.73,1.86-1.61,4.18q-.06.15-.12.33a3.59,3.59,0,0,0-.15.37c-.14.35-.28.7-.4,1.06l-.3.81c-.1.29-.19.57-.29.85A45.65,45.65,0,0,0,173.73,125.5Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.67,115.89a14.58,14.58,0,0,0,6.53,10.38l3.08-6.58-7-7-1-1S177.55,113.57,176.67,115.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,108.78c1.24,12.7-6.18,15-9,15.14-2.5.13-11,.74-13.53-11.76s3-17.1,8.63-18S196.77,96.08,198,108.78Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.12,106.1c-.3,0-.57-.11-.87-.16a1.45,1.45,0,0,1-.85-.33.47.47,0,0,1,0-.56,1.15,1.15,0,0,1,1.11-.29,1.68,1.68,0,0,1,1,.56A.49.49,0,0,1,197.12,106.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.89,106.77a8.26,8.26,0,0,0,.86-.2,1.51,1.51,0,0,0,.84-.38.47.47,0,0,0,0-.55,1.13,1.13,0,0,0-1.12-.24,1.64,1.64,0,0,0-1,.62A.48.48,0,0,0,188.89,106.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.86,109.86s-.07,0-.06.08c.07.87,0,1.87-.77,2.2,0,0,0,0,0,0C191,112,191.07,110.67,190.86,109.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,109c-1.4,0-1.37,2.77-.07,2.81S191.21,109,190,109Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.49,109.15c-.24.16-.48.44-.77.47s-.61-.25-.83-.53c0,0,0,0,0,0,0,.53.21,1.08.79,1.16s.9-.42,1-1C189.68,109.23,189.59,109.08,189.49,109.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.52,109.32s.07,0,.07.08c0,.87.1,1.87.88,2.15,0,0,0,0,0,0C195.51,111.47,195.36,110.14,195.52,109.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.3,108.41c1.39-.11,1.51,2.69.22,2.79S195.13,108.5,196.3,108.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.89,108.57c.23.14.46.4.72.41s.52-.31.71-.61c0,0,0,0,0,0,0,.53-.11,1.1-.62,1.22s-.83-.33-1-.85C196.73,108.67,196.8,108.51,196.89,108.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.92,116.57c.21.21.4.49.72.53a2.2,2.2,0,0,0,.94-.19s0,0,0,0a1.18,1.18,0,0,1-1.12.44.94.94,0,0,1-.66-.8S190.9,116.54,190.92,116.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.48,113.34s.21,1.3.23,1.91c0,0-.15.09-.36.1,0,0,0,0,0,0a2.89,2.89,0,0,1-2.85-1c0-.06,0-.12.09-.08a4.44,4.44,0,0,0,2.67.7c0-.18-.43-2.21-.33-2.22a5.48,5.48,0,0,1,1.39.29c-.36-2.71-1.15-5.34-1.46-8,0-.09.13-.13.16,0a44.16,44.16,0,0,1,1.94,8.58C196,113.87,194.73,113.44,194.48,113.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29,114.88a3.49,3.49,0,0,1-1.26,1.29,1.6,1.6,0,0,1-.95.2c-.73-.09-.83-.73-.78-1.29a3.55,3.55,0,0,1,.2-.88A4.59,4.59,0,0,0,194.29,114.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193,116.17a1.6,1.6,0,0,1-.95.2c-.73-.09-.83-.73-.78-1.29A1.65,1.65,0,0,1,193,116.17Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.37,113.76c-.61-.81-4.7-5.05-4.92-7.23-.13-1.27,2-4.72,2-4.72l-1.76-1.19,1.62.44-2.4-4,3,2.65s.54-3.24.82-4,5.53-5,5.53-5l-1.58,2.75s9.58-3.9,10.78-3.8c3,.26,9.51,5.08,9.51,5.08l-7-1.12s6.76,2.81,8.14,4.06,2.17,7.35,2.17,7.35L196,100.84l2.21,3.47a69.94,69.94,0,0,1-7,.75c-3.33-.12-11-2.9-11-2.9a33.6,33.6,0,0,1,0,3.84,25.83,25.83,0,0,1-1.77,4.9l-.8-2.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.08,112.22s-3.33-3.54-5-2.3,1.26,6.65,3.47,7.13a2.16,2.16,0,0,0,2.7-1.56Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,111.45s0,0,0,.06a5.43,5.43,0,0,1,3.28,3,1.2,1.2,0,0,0-1.81-.07.05.05,0,0,0,.05.08,1.31,1.31,0,0,1,1.51.25,6.82,6.82,0,0,1,.87,1.06c.08.13.31,0,.24-.12l0,0C177.86,113.76,176,111.35,174,111.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.15,162.93l-1.42,8.51H137.85s14.54-36.34,29.12-45c7.28-4.34,13.62-2,16.5,3.44.72,1.37,7.49,16.35,6.93,23C189.9,158.77,184.15,162.93,184.15,162.93Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.25,168.35l-.21,1.22H138.62c.16-.36.34-.77.53-1.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.7,165.63l-.2,1.22H139.81l.54-1.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.48,136.14c4.73,6.89,24.89,28.88,32.83,28.17,12.44-1.12,25.5-7.31,32.73-10.5,2.3-1-8.16-23-12.35-20.55-5.42,3.17-16.6,7.77-19.86,8.28-2.22.34-17-8-27.23-13.79C174,123,170.48,127.41,176.48,136.14Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,135.68l3.71-2.42a14.72,14.72,0,0,0,3.12-2.91A28,28,0,0,1,262.73,124c5.59,2.09,6.57,6.92.38,5.78-4.36-.8-7.32-1.72-8.81-1.58,0,0,4.46,5.11,3.54,8.93a72.35,72.35,0,0,1-3.11,9.82,15.34,15.34,0,0,1-1.89-.42,8.27,8.27,0,0,1-6.83,5.57l-5.89,2.6Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,127c2.88-.36,9-1,14.19.19,5.77,1.34,16.51,5.48,15.48,9.73-.76,3.11-5,1.89-5,1.89s4.08,2.65,2.78,5.31c-1.18,2.43-4.4,1.29-4.4,1.29s2.2,2,.6,4.15c-1.91,2.54-6.21-2.13-10.37-1.22C249.31,148.51,237,127,237,127Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.73,133a23.64,23.64,0,0,1,12.88,5.64c.09.09.07.2,0,.14a57.51,57.51,0,0,0-12.86-5.72S248.7,133,248.73,133Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.54,138.88a26.51,26.51,0,0,1,12.53,6.4c.08.09.06.2,0,.14a61.89,61.89,0,0,0-12.5-6.48S247.51,138.88,247.54,138.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.9,139l-8.27,20.38s-13.27-13.47-19.87-22.75-2.89-13.82,7-9.69S203.9,139,203.9,139Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.36,137.84c-.27.7-.65,1.37-1,2s-.62,1.37-.91,2.05c-.58,1.34-1.16,2.66-1.75,4-1.19,2.69-2.45,5.35-3.49,8.12,0,0,0,.08.07,0a70,70,0,0,0,3.88-7.86c.59-1.35,1.17-2.71,1.72-4.08.29-.7.56-1.4.81-2.11s.45-1.46.73-2.15C199.48,137.83,199.38,137.78,199.36,137.84Z",
    style: {
      fill: "#263238"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M177.9,139.43c2.23,2.49,4.35,5,6.54,7.55,1.07,1.28,2.16,2.53,3.25,3.78s2.2,2.5,3.32,3.74a49.28,49.28,0,0,1-3.6-3.48c-1.16-1.2-2.25-2.46-3.35-3.71s-2.15-2.56-3.17-3.87S178.85,140.8,177.9,139.43Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M178.41,141.2c.79.71,1.62,1.27,2.46,1.92a4.71,4.71,0,0,1-.73-.31c-.23-.13-.45-.28-.67-.43A3.74,3.74,0,0,1,178.41,141.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Brushes--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.58,402.05s3.68,12.26,8,24.77,8.24,41.27,7.43,42-10.5-27.21-13.3-40S361,403,361,403Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.64 401.74 366.56 410.07 361.92 411.19 360.52 402.62 363.64 401.74",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.64,401.74a6.89,6.89,0,0,0-1.1-6.25c-2-2.9-1.43-5.14-1.43-5.14s-5.22,6.68-.58,12.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.16,390c.26.43-.28,2.53.7,4.17s-3.81,4.1-3.42,1.63C358.88,393,360.67,389.24,361.16,390Z",
    style: {
      fill: "#99246A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.44,409.23s-3.55,9.91-7.68,20-8.56,33.58-7.92,34.22,9.81-21.92,12.66-32.3,5.06-21.07,5.06-21.07Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.4 408.97 383.65 415.69 387.41 416.81 388.93 409.82 386.4 408.97",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.4,409c.4-5.53,4.79-10,4.79-10s1.79,6.5-2.26,10.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.52,396.22s1.4,10.44,3.33,21.18,1.35,34.63.6,35.13-5-23.49-5.64-34.23-.55-21.67-.55-21.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.61 395.98 376.9 403.12 372.98 403.44 372.96 396.28 375.61 395.98",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,396.28s2.51-.25,2.65-.31a61.92,61.92,0,0,0,1.86-7.45c-.16-.2-8.45,1-8.4,1.75S373,396.28,373,396.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.11,
    y: 435.77,
    width: 29.22,
    height: 36.79,
    rx: 4.38,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.8,
    y: 429.96,
    width: 21.85,
    height: 5.81,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.14,435.64c5.07-.25,17.51-.26,19.19,0a0,0,0,0,1,0,.08,133.67,133.67,0,0,1-19.19,0C364.07,435.74,364.07,435.64,364.14,435.64Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.3788b5d56e860b2f5c5fc6ebecf3e50b.svg";
export { ForwardRef as ReactComponent };